(function () {
  'use strict';
 
 angular.module('SelfService.pages', [
    'ui.router',
    'SelfService.pages.dashboard',
    'SelfService.pages.home',
    'SelfService.pages.datos',
    'SelfService.pages.familiares',
    'SelfService.pages.evolucion',
    'SelfService.pages.vacaciones', 
    'SelfService.pages.capacitaciones', 
    'SelfService.pages.certificados',
    'SelfService.pages.login',
    'SelfService.pages.404',
    'SelfService.pages.recibos',
    'SelfService.pages.ganancias',
    'SelfService.pages.perfil',
    'SelfService.pages.reset',
    'SelfService.pages.olvido' ,
    'SelfService.pages.licencias',
    'SelfService.pages.supervisor'
  ])
  .config(routeConfig);

  function routeConfig($urlRouterProvider, $httpProvider) {
         //HDY CODIGO PARA DESHABILITAR EL CACHING DE EXPLORER 
         //INICIO
         var ua = window.navigator.userAgent;
         var msie = ua.indexOf("MSIE ");

         if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
           
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};    
                }    
            
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
        }
        //FIN CODIGO
    $urlRouterProvider.otherwise('/login');
    $httpProvider.interceptors.push(['$q', '$location', '$localStorage', function ($q, $location, $localStorage) {
        return {
            'request': function (config) {
            try{
                config.headers = config.headers || {}; 

                if ($localStorage.user.token) {
                    config.headers.Authorization = 'Bearer ' + $localStorage.user.token;
                }
                    return config;
                }
            catch(exception){
                return config;
            }
        }, 'responseError': function (response) {
                if ( response.status === 401 || response.status === 403 ) {
                    $location.path('/login');
                }
                return $q.reject(response);
            }
        };
    }]);
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'SelfService.theme.components',
      'SelfService.theme.inputs'
  ]);

})();

(function () {
  'use strict';

  angular.module('SelfService.pages.404', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('404', {
          url: '/404',
          templateUrl: 'app/pages/404/404.html',
          title: 'No encontrado'
        });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.capacitaciones', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.capacitaciones', {
        url: '/capacitaciones/capacitaciones',        
        templateUrl:  'app/pages/capacitaciones/capacitaciones/capacitaciones.html',
        controller: 'capacitacionesPageCtrl',
        title: 'Capacitaciones',
        sidebarMeta: {
          icon: 'ion-university',
          order: 812,
      }
      });
  }
 
})();
(function () {
  'use strict';

  angular.module('SelfService.pages.certificados', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.certificados', {
          url: '/documentos',
          templateUrl: 'app/pages/certificados/certificados.html',
          title: 'Documentos',
          controller: 'CertificadosPageCtrl', 
          sidebarMeta: {
            icon: 'ion-compose',
            order: 830,
          },
        });
  }

})();
 
(function () {
  'use strict';

  angular.module('SelfService.pages.home', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.home', {
        url: '/home',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Inicio',
        sidebarMeta: {
          icon: 'ion-home',
          order: 0,
        },
      });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.datos', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.datos', {
          url: '/datos',
          templateUrl: 'app/pages/datos/datos.html',
          title: 'Datos Personales',
          controller: 'LegajoCtrl',
          sidebarMeta: {
            icon: 'ion-person',
            order: 800,
          },
        });
  }

})();
(function () {
    'use strict';
  
    angular.module('SelfService.pages.evolucion', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.evolucion', {
            url: '/evolucion',
            templateUrl: 'app/pages/evolucion/evolucion.html',
            title: 'Carrera Profesional',
            controller: 'EvolucionCtrl',
            sidebarMeta: { 
              icon: 'ion-briefcase',
              order: 811,
            },
          });
    }
  
  })();

(function () {
  'use strict';

  angular.module('SelfService.pages.familiares', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.familiares', {
          url: '/familiares',
          templateUrl: 'app/pages/familiares/familiares.html',
          title: 'Datos Familiares',
          controller: 'FamiliaresPageCtrl',
          sidebarMeta: {
            icon: 'ion-person-stalker',
            order: 808,
          },
        });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.ganancias', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.ganancias', {
          url: '/ganancias',
          templateUrl: 'app/pages/ganancias/ganancias.html',
          title: 'Ganancias',
          controller: 'GananciasPageCtrl',
          sidebarMeta: {
            icon: 'ion-document',
            order: 850,
          },
        });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.licencias', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.licencias', {
        url: '/licencias/solicitarLicencias',        
        templateUrl:  'app/pages/licencias/solicitarLicencias/solicitarLicencias.html',
        controller: 'SolicitarLicenciasPageCtrl',
        title: 'Licencias',
        sidebarMeta: {
          icon: 'ion-calendar',
          order: 820,
      }
      });
  }
 
})();
(function () {
    'use strict';

    angular.module('SelfService.pages.login', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.html',
                title: 'Login',
                controller: 'LoginController'
            });
    }

    angular.module('SelfService.pages.login').controller('LoginController', LoginController)
    function LoginController($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, md5, SELFS_CONFIG) {
        var vm = this;

        $scope.elegirEmpresa = function (empresas) {

            var empresaModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/login/modals/elegirEmpresaModal.html',
                controller: 'elegirEmpresaModalCtrl',
                resolve: {
                    items: function () {
                        return { empresas: empresas };
                    }
                }
            });

            empresaModal.result.then(function (empresas) {
                $localStorage.user = empresas;
                $location.path('/dashboard/home');

            }, function () {
                // si hay dismissed no hago reload
            });
        }

        $scope.errorUsuario = function (error) {

            toastr.error('Usuario o contraseña incorrectos.', 'Error', {
                "autoDismiss": false,
                "positionClass": "toast-top-left",
                "type": "error",
                "timeOut": "3000",
                "extendedTimeOut": "1000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        }

        $scope.login = function () {
            $http({
                method: 'POST',
                url: SELFS_CONFIG.url + '/login',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { username: $scope.user.usuario, password: md5.createHash($scope.user.password || '') }
            }).then(function (response) {

                if (response.data.length > 1) {
                    $scope.elegirEmpresa(response.data);
                } else if (response.data.length == 1) {
                    $localStorage.user = response.data[0];
                    $location.path('/dashboard/home');
                } else {
                    $scope.errorUsuario();
                }

            })
                .catch(function (error) {

                    toastr.error('Usuario o contraseña incorrectos.', 'Error', {
                        "autoDismiss": false,
                        "positionClass": "toast-top-left",
                        "type": "error",
                        "timeOut": "3000",
                        "extendedTimeOut": "1000",
                        "allowHtml": false,
                        "closeButton": false,
                        "tapToDismiss": true,
                        "progressBar": false,
                        "newestOnTop": true,
                        "maxOpened": 0,
                        "preventDuplicates": false,
                        "preventOpenDuplicates": false
                    });

                    $scope.invalid = true;
                });
        };

        $scope.open = function (page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function () {
                        return $scope.items;
                    }
                }
            });
        };

        $scope.olvidoDeContrasenia = function () {
            $location.path('/olvido');
        }
    };

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.olvido', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('olvido', {
          url: '/olvido',
          templateUrl: 'app/pages/olvido/olvido.html',
          title: 'Olvido de contraseña',
          controller: 'OlvidoPageCtrl'
        });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.perfil', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.perfil', {
          url: '/perfil',
          templateUrl: 'app/pages/perfil/perfil.html',
          title: 'Perfil',
          controller: 'PerfilPageCtrl'
        });
  }

})();

(function () {
  'use strict';

  angular.module('SelfService.pages.recibos', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.recibos', {
          url: '/recibos',
          templateUrl: 'app/pages/recibos/recibos.html',
          title: 'Recibos',
          controller: 'RecibosPageCtrl',
          sidebarMeta: {
            icon: 'ion-document',
            order: 840,
          },
        });
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.reset', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('reset', {
        url: '/reset/:token',
        templateUrl: 'app/pages/reset/reset.html',
        title: 'Reset contraseña',
        controller: 'ResetPageCtrl',
        resolve: {
          verifyToken: function ($stateParams, $location, SELFS_CONFIG, $http) {
          
            $http({ method: 'GET', url: SELFS_CONFIG.url + '/reset/' + $stateParams.token })
              .success(function (data) {
              })
              .error(function (status) {
                $location.path('/login');
              });          
          }
        }
      });  
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/sides/sides.html',
          redirectTo: 'dashboard.home'
        });
  }

})();

(function () {
  'use strict';
  
  angular.module('SelfService.pages.supervisor', [
    'SelfService.pages.supervisor.novedadespersonal',
    'SelfService.pages.supervisor.equipotrabajo',
    'SelfService.pages.supervisor.solicitarpersonal'
  ])
    .config(routeConfig);
    
  function routeConfig($stateProvider) {
    $stateProvider.state('dashboard.supervisor', {
        url: '/supervisor',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Supervisor',
        sidebarMeta: {
          icon: 'ion-flag',
          order: 852,
        },         
      }); 
    }     
     
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.vacaciones', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.vacaciones', {
        url: '/vacaciones/solicitarVacaciones',        
        templateUrl:  'app/pages/vacaciones/solicitarVacaciones/solicitarVacaciones.html',
        controller: 'SolicitarVacacionesPageCtrl',
        title: 'Vacaciones',
        sidebarMeta: {
          icon: 'ion-plane',
          order: 821,
      }
      });
  }
 
})();

(function () {
  'use strict';

  angular.module('SelfService.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme.inputs', []);

})();

(function () {
    'use strict';
  
    angular.module('SelfService.pages.supervisor.equipotrabajo', [])
        .config(routeConfig);
  
    /** @ngInject */  
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.supervisor.equipotrabajo', {
            url: '/supervisor/equipotrabajo',
            templateUrl: 'app/pages/supervisor/equipotrabajo/equipotrabajo.html',
            title: 'Equipo de Trabajo',
            controller: 'EquipotrabajoPageCtrl',
            sidebarMeta: {
              icon: 'ion-calendar',
              order: 852,
            },
          });
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('SelfService.pages.supervisor.novedadespersonal', [])
    .config(routeConfig)
     .run(function(calendarEventTitle) {
       calendarEventTitle.monthView = function(event) {
        return event.title;
      };
       calendarEventTitle.monthViewTooltip = function(event) {
        return event.title;
      };
     })
    ;
  
    /** @ngInject */ 
      
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.supervisor.novedadespersonal', {
            url: '/supervisor/novedadespersonal',
            templateUrl: 'app/pages/supervisor/novedadespersonal/novedadespersonal.html',
            title: 'Novedades',
            controller: 'NovedadespersonalPageCtrl',
            sidebarMeta: {
              icon: 'ion-calendar',
              order: 851,
            },
          });
    }
  
  })();
(function () {
  'use strict';

  angular.module('SelfService.pages.supervisor.solicitarpersonal', [])
      .config(routeConfig);

  /** @ngInject */  
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.supervisor.solicitarpersonal', {
          url: '/supervisor/solicitarpersonal',
          templateUrl: 'app/pages/supervisor/solicitarpersonal/solicitarpersonal.html',
          title: 'Solicitar Personal',
          controller: 'SolicitarPersonalPageCtrl',
          sidebarMeta: {
            icon: 'ion-calendar',
            order: 870,
          },
        });
  }

})();
'use strict';

angular.module('SelfService', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngStorage',
  'angular-progress-button-styles',
  'angular-md5',
  'moment-picker',
  'naif.base64',
  'SelfService.theme',
  'mwl.calendar',
  'rzSlider',
  'SelfService.pages',
])

angular.module('SelfService').controller('selfsController', function ($scope,  $localStorage, $location) {
	$scope.logout = function() {
		$localStorage.user.token = null;
		$location.path('/login');
	}

  $scope.nombreUsuario = 	$localStorage.user.nombre;
  $scope.nombreRol = 	$localStorage.user.rol;
  $scope.emp = 	$localStorage.user.emp;
 
});
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('SelfService.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('SelfService.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

(function () {
  'use strict';

  angular.module('SelfService.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.pages.certificados')
    .controller('CertificadosPageCtrl', CertificadosPageCtrl);

  function CertificadosPageCtrl($scope, $localStorage, $http, toastr, toastrConfig, SELFS_CONFIG) {

    if (!$localStorage.user.token) {
      $location.path('/login');
    }

    $scope.certificado = {};
    $scope.indice = null;
    $scope.tiposCertificado = [];
    // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
    $scope.itemsByPage = 5;

    $scope.getCertificados = function () {
      // Llamada a datos de Tickets
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/certificados' })
        .success(function (data) {
          $scope.certificadosCollection = data;
        })
        .error(function (data, status, headers, config) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    }

    $scope.getCertificados();

    $scope.refresh = function () {
      $scope.getCertificados();
    }

    // LLAMADA PARA TRAER LOS DATOS DEL SELECT DE TIPOS DE CERTIFICADOS.
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/codigos' })
      .success(function (data) {
        $scope.tiposCertificado = data;
      })
      .error(function (status) {
        toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
      });


    $scope.getCertificado = function (idCertificado) {
      $http({
        method: 'GET',
        url: SELFS_CONFIG.url + '/certificados/' + idCertificado,
        responseType: 'arraybuffer'
      })
        .success(function (data, status, headers, config) {
          var contentDispositionHeader = headers('Content-Disposition');
          var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
          var filename = result.replace(/"/g, '');

          //var blob = new Blob([data], {type: "application/pdf"});
          var blob = new Blob([data]);

          //HDY: AGREGO EL SIGUIENTE CÓDIGO PARA QUE SE PUEDE DESCARGAR ARCHIVOS EN IE11
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          }
          else {
            var objectUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = objectUrl;
            a.download = filename;
            a.target = '_blank';
            //HDY: AGREGO LINEA DE CÓDIGO PARA QUE FUNCIONE EN FIREFOX
            if (document.body != null) {
              document.body.appendChild(a);
            }
            a.click();
          }

        })
        .error(function (data, status, headers, config) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    }

    // FUNCION PARA TRAER LA FECHA DE LA LICENCIA.
    $scope.getFechaCertificado = function (certificado) {
      for (var i = 0; i < $scope.tiposCertificado.length; i++) {
        if (certificado.tipoCertificado === $scope.tiposCertificado[i].codnov) {
          $scope.indice = i;
        }
      }

      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/fechas/' + certificado.tipoCertificado })
        .success(function (data) {
          $scope.fechaCerfif = data;
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    }

    // FUNCION PARA VACIAR EL ARCHIDO SUBIDO DEL INPUT
    $scope.resetFileUploader = function () {
      angular.element("#upcontrol").value = '';
      $scope.certificado.miArchivo = '';
    }

    // FUNCION PARA CREAR UN NUEVO CERTIFICADO.
    $scope.guardarCertificado = function () {
      if($scope.tiposCertificado[$scope.indice].rcertif == 'S') {
        $scope.noveId = $scope.certificado.FechaCerfif.id;
      } else {
        $scope.noveId = 0;
      }
      
      if ($scope.certificado.miArchivo === undefined || $scope.certificado.miArchivo === '' || $scope.fileInvalid == true || $scope.fileInvalidString == true || $scope.certificado.descripcion === undefined || $scope.certificado.descripcion === '' || $scope.certificado.tipoCertificado === undefined || $scope.certificado.tipoCertificado === '') {
        null;
      }
      else {
        var fData = {
          "emp": $localStorage.user.emp,
          "legajo": $localStorage.user.legajo,
          "descripcion": $scope.certificado.descripcion,
          "tipo": $scope.certificado.tipoCertificado,
          "nombre": $scope.certificado.miArchivo.filename,
          "datosBase64": $scope.certificado.miArchivo.base64
        }

        /* Envío de captura */
        $http({ method: 'POST', url: SELFS_CONFIG.url + '/certificados/id/' + $scope.noveId, data: JSON.stringify(fData) })
          .success(function (data, status, headers, config) {
            // borra formulario
            $scope.certificado.descripcion = '';
            $scope.certificado.tipoCertificado = '';

            $scope.certificadoForm.$setPristine();
            $scope.certificadoForm.$setUntouched();

            $scope.refresh();
            $scope.resetFileUploader();
            angular.element("input[type='file']").val(null);
            toastr.success("El certificado se ha cargado correctamente");

          })
          .error(function (data) {
            toastr.error("La carga del certificado ha fallado, por favor intente nuevamente.");
          });
      }
    };

    // FUNCION UTILIZADA PARA SUBIR EL ARCHIVO.
    $scope.uploadFile = function (event) {
      if (event.target.files[0] !== undefined) {

        var filename = event.target.files[0].name.toLowerCase();
        //Sanitizo de caracteres ilegales el nombre del archivo subido en la carga de ticket 
        //Caracteres ilegeales en Windows \/:?"<>|
        filename = filename.replace(/[^a-zA-Z0-9!.,@#$%*()& +_-]/g, '');

        var extension = event.target.files[0].name.split(".").pop().toLowerCase();
        var extensionesValidas = ['png', 'jpg', 'jpeg', 'doc', 'docx', 'pdf', 'xls', 'xlsx'];
        var tamanio = event.target.files[0].size;

        if (extensionesValidas.indexOf(extension) > -1 && tamanio <= 5242880) {
          $scope.fileInvalid = false;
        } else {
          $scope.fileInvalid = true;
        }

        if (filename.length > 90) {
          $scope.fileInvalidString = true;
        } else {
          $scope.fileInvalidString = false;
        }

      } else {
        $scope.fileInvalid = false;
      }
      $scope.certificadoForm.$setValidity("certificado.miArchivo", !$scope.fileInvalid);
      $scope.certificadoForm.$setValidity("archivo", !$scope.fileInvalidString);
      $scope.$apply();
    };
  }
})();

angular.module('SelfService.pages.certificados').directive('customOnChange', function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var onChangeHandler = scope.$eval(attrs.customOnChange);
      element.bind('change', onChangeHandler);    
      }
  };
});
(function () {
  'use strict';

 angular.module('SelfService.pages.datos').controller('LegajoCtrl', LegajoCtrl);

  function LegajoCtrl($scope, $http, $uibModal, toastr, toastrConfig, $localStorage, $q, SELFS_CONFIG) {
    
    $scope.getDatos = function() {
    return $http({ method: 'GET', url: SELFS_CONFIG.url + '/empleados' })
      .success(function (data, status, headers, config) {
    
        // datos originales
        $scope.datosOri = data;
 
        $scope.datos.emp = data.emp;
        $scope.datos.legajo = data.legajo;
        $scope.datos.nombre = data.nombre;
        $scope.datos.domcalle = data.domcalle;
        $scope.datos.domnro = data.domnro;
        $scope.datos.dompiso = data.dompiso;
        $scope.datos.domdepto = data.domdepto;
        $scope.datos.pais = data.pais;
        $scope.datos.descpais = data.descpais;
        $scope.datos.pcia = data.pcia;
        $scope.datos.descpcia = data.descpcia;
        $scope.datos.ciudad = data.ciudad;
        $scope.datos.barrio = data.barrio;
        $scope.datos.codp = data.codp;
        $scope.datos.telef = data.telef;
        $scope.datos.email = data.email;
        $scope.datos.codnac = data.codnac;
        $scope.datos.desccodnac = data.desccodnac;
        $scope.datos.ecivil = data.ecivil;
        $scope.datos.descecivil = data.descecivil; 
        
 
        $scope.datePickerFnacim = {};
        if (typeof data.fnacim === '' || !data.fnacim || data.fnacim === '01/01/0001') {
              $scope.datePickerFnacim = '';
              $scope.datos.fnacim = null;
        }else{
              var castFnacim = moment(data.fnacim, 'DD/MM/YYYY');
              $scope.datePickerFnacim = castFnacim;
        }

        $scope.datePickerFcasam = {};
        //Evaluo el valor de data.fcasam que viene del json.  
        //Si la fecha viene null, vacia o con string 01/01/0001 (valor que pone el datepicker por defecto) al ng-model del calendario le paso un valor vacio
        if (typeof data.fcasam === '' || !data.fcasam || data.fcasam === '01/01/0001') {
              $scope.datePickerFcasam = '';
              $scope.datos.fcasam = null;
        }else{
              //Sino casteo el string a un date con moment.js 
              var castFcasam = moment(data.fcasam, 'DD/MM/YYYY');
              $scope.datePickerFcasam = castFcasam;
        }

      })
      .error(function (data, status, headers, config) {
        if (status === 401 || status === 403 ) {
            toastr.error('La sesión ha caducado, ingrese sus credenciales nuevamente.');  
      } else {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        }
      });

    }

    //SELECTS 
    //TODO: REFACTORING
    

    //LLAMADA PARA CARGAR LOS SELECTS
    function getPaises () {
        return $http({ method: 'GET', url: SELFS_CONFIG.url + '/paises' })
          .success(function (traerPaises) {
            $scope.paisesBase = traerPaises;
          });
   }
    

    function getPcias (){
    //LLAMADA PARA CARGAR LOS SELECTS
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/provincias' })
      .success(function (traerPcia) {
        $scope.pciaBase = traerPcia;
      });
    }
    

    //LLAMADA PARA CARGAR LOS SELECTS
    function getCiudades (){
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/ciudades' })
      .success(function (traerCiudades) {
        $scope.ciudadesBase = traerCiudades;
      });
    }
    

    //LLAMADA PARA CARGAR LOS SELECTS
    function getNacionalidades (){
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/nacionalidades' })
      .success(function (traerNacionalidades) {
        $scope.nacionalidadesBase = traerNacionalidades;
      });
    }
    

    //LLAMADA PARA CARGAR LOS SELECTS
     function getEstadoCivil (){
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/valores/tipos-estado-civil' })
      .success(function (traerEstadosCiviles) {
        $scope.estadosCivilesBase = traerEstadosCiviles;
      });
    }
    //FIN SELECTS

    /* Acción en Submit*/
    $scope.actualizarLegajo = function () {
     
        
        //VERIFICO SI HAY CAMBIOS ENTRE EL HTML Y EL JSON PARA NO REALIZAR PUT INNECESARIOS EN LA BASE
        var cambioData     = false;

        //angular.equals retorna true si los dos objetos son iguales
        cambioData   = angular.equals($scope.datos, $scope.datosOri);
        if (!cambioData) {
          $http({method: 'PUT', url: SELFS_CONFIG.url + '/empleados', data: JSON.stringify($scope.datos)})
            .success(function (response) {
              $scope.datosOri = response;
              toastr.success('', 'Los datos se actualizaron correctamente.');
            })
            .error(function (response, status, headers, config, statusText, message) {
              toastr.error('Código de error: ' + response.status, 'Falló la actualización de datos.'+  response.message);
            });
        }
    }

    //Datepickers
    $scope.onChangeDateFnacim = function (newValue) {

        if (typeof newValue === 'undefined' || !newValue) {
            $scope.datos.fnacim = null;
        }else{
            $scope.newFnacim = newValue;
            var castDatePicker = moment($scope.newFnacim).format('DD/MM/YYYY');
            $scope.datos.fnacim = castDatePicker;  
        }


    };

    $scope.filterPorPais = function (pais) {
      return function (item) {
          if (item.pais == pais)
          {
              return true;
          }
          return false;
      };
    };
    
    $scope.onChangeDateFcasam = function (newValue) {
        
        if (typeof newValue === 'undefined' || !newValue) {
            $scope.datos.fcasam = null;
        }else{
            $scope.newFcasam = newValue;
            var castDatePicker = moment($scope.newFcasam).format('DD/MM/YYYY');
            $scope.datos.fcasam = castDatePicker;  
        }
    };

   function getDatosSelects () {
      getCiudades();
      getEstadoCivil();
      getPaises();
      getPcias();
      getNacionalidades();
   }
try {
      $scope.datos    = {};
      $scope.datosOri = [];
      $scope.paisesBase = [];
      $scope.pciaBase = [];    
      $scope.ciudadesBase = [];
      $scope.estadosCivilesBase = [];    
      $scope.nacionalidadesBase = [];
      
      if ($scope.getDatos()) {
         getDatosSelects();
      }
 
    } catch (error) {
      console.log(error);
    }

 };
})();

(function () {
    'use strict';
   
    angular.module('SelfService.pages.evolucion')
      .controller('EvolucionCtrl', EvolucionCtrl);
  
   
    function EvolucionCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG) {
      //TOKEN DE SEGURIDAD PARA EL LOGIN 
      if (!$localStorage.user.token) {
        $location.path('/login');
      }
      $scope.rol = $localStorage.user.rol;
  
      // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
      $scope.itemsByPage=5;
  
        //LLAMADA PARA CARGAR LAS LICENCIAS SOLICITADAS POR EL PERSONAL      
        $scope.Tareas = [];
        $scope.getTareas = function () {
          $http({ method: 'GET', url: SELFS_CONFIG.url + '/evolucion/tarea' })
            .success(function (data) {
              $scope.tareas = data;
              $scope.lengthtareas = $scope.tareas.length;
            })
            .error(function (status) {
              toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
            });
  
        }
  
        $scope.getTareas();
  
        $scope.refresh = function () {
          $scope.getTareas();
        }

        
        $scope.Funciones = [];
        $scope.getFunciones = function () {
          $http({ method: 'GET', url: SELFS_CONFIG.url + '/evolucion/funcion' })
            .success(function (data) {
              $scope.funciones = data;
              $scope.lengthfunciones = $scope.funciones.length;
            })
            .error(function (status) {
              toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
            });
  
        }
  
        $scope.getFunciones();
  
        $scope.refresh = function () {
          $scope.getFunciones();
        }


    }
  
  
  })();
   
(function () {
  'use strict';

  angular.module('SelfService.pages.familiares')
    .controller('FamiliaresPageCtrl', FamiliaresPageCtrl);

  /** @ngInject */
  function FamiliaresPageCtrl($scope, $uibModal, $location, $localStorage, $http, SELFS_CONFIG, toastr, toastrConfig, parametroUrl) {

    //TOKEN DE LOGIN
      if (!$localStorage.user.token) {
         $location.path('/login');
       }
   
    //Inicializo el array
    $scope.familiaresTableData = []; 
    
    // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
    $scope.itemsByPage=5;

    $scope.getFamiliares = function () {
    $http({method: 'GET', url: SELFS_CONFIG.url + '/familiares'}) 
      .success( function(data) {
        
           //Paso los datos del json al array para armar la tabla 
           $scope.familiaresTableData = data;

      })
      .error( function(data, status, headers, config) {
          toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
      });
     }
  
   $scope.getFamiliares();

   $scope.openModal = function (codfam,numfam){
        
        parametroUrl.setParametro(codfam,numfam);
        
        var familiarModal = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/familiares/modals/familiaresModal.html',
            controller: 'familiaresModalCtrl',
            resolve: {
            items: function () {
                return $scope.items;
                }
            }
        });

      familiarModal.result.then(function () {
          // reload de lista de familiares
             $scope.getFamiliares();
      }, function () {
          // si hay dismissed no hago reload
      });   
   }
}

})();

angular.module('SelfService.pages.familiares').factory("parametroUrl", function(SELFS_CONFIG){

    this.l_url = ''; 

    this.setParametro = function(codfam,numfam) {
        this.l_url = SELFS_CONFIG.url + "/familiares/" + codfam + "/" + numfam;
    };       

    this.getParametro = function() {
        return this.l_url;
    };
    return {
        getParametro: this.getParametro,
        setParametro: this.setParametro
    };
});
(function () {
  'use strict';

  angular.module('SelfService.pages.ganancias')
      .controller('GananciasPageCtrl', GananciasPageCtrl);

  /** @ngInject */
  function GananciasPageCtrl($scope, $location, $localStorage, $http, toastr, toastrConfig, SELFS_CONFIG) {

    if (!$localStorage.user.token) {
        $location.path('/login');
      }
   
      // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
      $scope.itemsByPage=5;

    // Llamada a datos de Tickets
    $http({method: 'GET', url: SELFS_CONFIG.url + '/formularios-649/detallado'})
    .success( function(data) {
      $scope.detallado649Collection = data;
    })
    .error( function(data, status, headers, config) {
        toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
    });

    $http({method: 'GET', url: SELFS_CONFIG.url + '/formularios-649/legal'})
    .success( function(data) {
      $scope.formularios649Collection = data;
    })
    .error( function(data, status, headers, config) {
        toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
    });
    
    $scope.getDetallado = function (idArchivo){
      $http({method: 'GET', 
            url: SELFS_CONFIG.url + '/formularios-649/detallado/' + idArchivo,
            responseType: 'arraybuffer'
            }) 
        .success( function(data, status, headers, config) {
          var contentDispositionHeader = headers('Content-Disposition');
          var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
          var filename = result.replace(/"/g, '');     

          var blob = new Blob([data], {type: "application/pdf"});
        
          //HDY: AGREGO CODIGO PARA LINEA DE CÓDIGO PARA QUE FUNCIONE EN EXPLORER
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob,filename);
          }
          else {
                    var objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                          a.href = objectUrl;
                          a.download = filename;
                          a.target = '_blank';
                          //HDY: AGREGO LINEA DE CÓDIGO PARA QUE FUNCIONE EN FIREFOX
                          if(document.body != null)
                          { 
                            document.body.appendChild(a); 
                          }
                          a.click(); 
          }

        })
        .error( function(data, status, headers, config) {
            toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
        });
    }

    $scope.getFormulario = function (idArchivo){
      $http({method: 'GET', 
            url: SELFS_CONFIG.url + '/formularios-649/legal/' + idArchivo,
            responseType: 'arraybuffer'
            }) 
        .success( function(data, status, headers, config) {
          var contentDispositionHeader = headers('Content-Disposition');
          var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
          var filename = result.replace(/"/g, '');     

          var blob = new Blob([data], {type: "application/pdf"});
        
          //HDY: AGREGO CODIGO PARA LINEA DE CÓDIGO PARA QUE FUNCIONE EN EXPLORER
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob,filename);
          }
          else {
                    var objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                          a.href = objectUrl;
                          a.download = filename;
                          a.target = '_blank';
                          //HDY: AGREGO LINEA DE CÓDIGO PARA QUE FUNCIONE EN FIREFOX
                          if(document.body != null)
                          { 
                            document.body.appendChild(a); 
                          }
                          a.click(); 
          }

        })
        .error( function(data, status, headers, config) {
            toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
        });
    }
}
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.olvido')
    .controller('OlvidoPageCtrl', OlvidoPageCtrl);

  /** @ngInject */
  function OlvidoPageCtrl($scope, toastr, $http, SELFS_CONFIG, $location) {
    $scope.emailValido = false;

    $scope.emailEnviado = function () {
      return $scope.emailValido;
    }

    $scope.volver = function () {
      $location.path('/login');
    }
    
    $scope.submitForm = function (isValid, parametros) {
      if (isValid) {

        $http({
          method: 'POST',
          url: SELFS_CONFIG.url + '/reset',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          data: { mailTo: parametros.inputEmail }
        })
          .then(function (response) {
            $scope.emailValido = true;
          })
          .catch(function (error) {
            toastr.error('El email informado no está registrado en SelfService.');            
          });

      };
    };
  }
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.perfil')
    .controller('PerfilPageCtrl', PerfilPageCtrl);

  /** @ngInject */
  function PerfilPageCtrl($scope, fileReader, $filter, $uibModal, $http, md5, toastr, toastrConfig, SELFS_CONFIG) {
    
    $scope.cambiarPassword = function (){     
          // ejecuto el cambio si es válido y si no es undefined o vacío 
          if( $scope.perfilForm.inputPassword.$valid && $scope.inputPassword != undefined && $scope.inputPassword != ''){
            
            $http({ method: 'PUT',  
                url: SELFS_CONFIG.url + '/login/password-change/',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                transformRequest: function(obj) {
                    var str = [];
                    for(var p in obj)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                }, 
                data: {"new-password": md5.createHash($scope.inputConfirmPassword || '')}
            })
            .then( function(response) { 
                // Borra formulario
                $scope.inputPassword = '';
                $scope.inputConfirmPassword = '';

                $scope.perfilForm.$setPristine();
                $scope.perfilForm.$setUntouched();

                toastr.success('', 'La contraseña fue actualizada correctamente.');
            });
        }   
    }
    
    $scope.picture = $filter('profilePicture')('no-photo.jpg');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function () {
  'use strict';

angular.module('SelfService.pages.perfil')
    .directive('checkPass', checkPass);

function checkPass() {
      return {
        restrict: 'A', // only activate on element attribute
        require: '?ngModel', // get a hold of NgModelController
        link: function(scope, elem, attrs, ngModel) {
          if(!ngModel) return; // do nothing if no ng-model
          // watch own value and re-validate on change
          scope.$watch(attrs.ngModel, function() {
            validate();
          });

          // observe the other value and re-validate on change
          attrs.$observe('checkPass', function (val) {
            validate();
          });

          var validate = function() {
            // values
            var val1 = ngModel.$viewValue;
            var val2 = attrs.checkPass;

            // set validity
            ngModel.$setValidity('checkPass', val1 === val2 || val1 === undefined || val2 === undefined );
          };
        }
      }
    };

})();    
(function () {
  'use strict';

  angular.module('SelfService.pages.perfil')
    .directive('complexPass', complexPass);

function complexPass() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attrs, ngModel) {
      ngModel.$parsers.unshift(function(viewValue) {
        if (viewValue.length >= 8 || viewValue === undefined || viewValue === '') {
          ngModel.$setValidity('complexPass', true);
          return viewValue;
        }
        else {
          ngModel.$setValidity('complexPass', false);
          return undefined;
        }

      });
      }
    }
};

})();

(function () {
    'use strict';

    angular.module('SelfService.pages.recibos')
        .controller('RecibosPageCtrl', RecibosPageCtrl);

    /** @ngInject */
    function RecibosPageCtrl($scope, $location, $localStorage, $http, SELFS_CONFIG, toastr, toastrConfig, $uibModal) {

        if (!$localStorage.user.token) {
            $location.path('/login');
        }

        var pendientes = [];
        var firmados = [];
        var disconforme = [];
        // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
        $scope.itemsByPage=5;

      //Función para cambiar el label del botón filtro de la tabla de recibos
        $scope.toggleText = 'Filtrar recibos';

        $scope.toggle = function (newValue) {

            if (newValue === "P") {
                $scope.toggleText = 'Pendientes';
            } else if (newValue === "F") {
                $scope.toggleText = 'Firmados';
            } else if (newValue === "D") {
                $scope.toggleText = 'Firmandos no conforme';
            } else {
                $scope.toggleText = 'Todos los recibos';
            }
        
        };



        $scope.getRecibos = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/recibos' })
            .success(function (data) {
                $scope.recibosCollection = data;

            })
            .error(function (data, status, headers, config) {
                toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
            });

        }


        $scope.getRecibosEstados = function () {
            $http({ method: 'GET', url: SELFS_CONFIG.url + '/recibos/estados' })
            .success(function (data) {
 
                $.each(data, function (key) {
                    if(data[key].tipo === 'Digital' ) {
                        if (data[key].estado === 'P') {
                                pendientes.splice(0,1, data[key].porcentaje); 
                                $scope.pendientesString = data[key].porcentaje;
                            } else if (data[key].estado === 'F') {
                                firmados.splice(0,1, data[key].porcentaje);
                                $scope.firmadosString = data[key].porcentaje;
                            } else if (data[key].estado === 'D') {
                                disconforme.splice(0,1, data[key].porcentaje);
                                $scope.disconformeString = data[key].porcentaje;
                            }
                    } 
                 });

          //Asigno los valores al css
            $scope.pendientesCSS  =  { "width" : pendientes + "%"}
            $scope.firmadosCSS    =  { "width" : firmados + "%"}
            $scope.disconformeCSS =  { "width" : disconforme + "%"}
           
 
          //Si vienen todos los estados de recibos vacios entonces no muestro el grafico con los estados de los recibos  
          $scope.estadosRecibosMostrar = true;
                if(pendientes.length == 0 && firmados.length == 0 && disconforme.length == 0 ){
                   $scope.estadosRecibosMostrar = false;
                }
 
            })
            .error(function (data, status, headers, config) {
                toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
            });

           //Limpio los arrays
             pendientes.splice(0, 1);
             firmados.splice(0, 1);
             disconforme.splice(0, 1);
 
        }


        // obtengo lista de recibos
        $scope.getRecibos();

        // obtengo datos para indicador
        $scope.getRecibosEstados();

        $scope.getRecibo = function (idArchivo) {
            $http({
                method: 'GET',
                url: SELFS_CONFIG.url + '/recibos/' + idArchivo,
                responseType: 'arraybuffer'
            })
                .success(function (data, status, headers, config) {                    
                    var contentDispositionHeader = headers('Content-Disposition');
                    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
                    var filename = result.replace(/"/g, '');

                    var blob = new Blob([data], { type: "application/pdf" });

         //HDY: AGREGO CODIGO PARA QUE FUNCIONE EN EXPLORER DESCARGA DE ARCHIVO
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob,filename);
          }
          else {
                    var objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = filename;
                    a.target = '_blank';
                    //HDY: AGREGO LINEA DE CÓDIGO PARA QUE FUNCIONE EN FIREFOX
                    if (document.body != null) { document.body.appendChild(a); }

                    a.click();
          }
                })
                .error(function (data, status, headers, config) {
                    toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
                });
        }


        //LLAMADA DEL MODAL PASSWORDRECIBOS 
        /*
            $scope.open = function (page,size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                controller: 'passwordRecibosModalCtrl',
                resolve: {
                items: function () {
                    return $scope.items;
                    }
                }
            });
        };   
        */

        //LLAMADA DEL MODAL FIRMAR RECIBOS 
        $scope.openModalFirma = function (reciboAFirmar) {

            var modalFirma = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/recibos/modals/firmarRecibosModal.html',
                size: 'lg',
                controller: 'firmarRecibosModalCtrl',
                resolve: {
                    recibo: function () {
                        return reciboAFirmar;
                    }
                }
            });

            modalFirma.result.then(function () {
                        // obtengo lista de recibos
                        $scope.getRecibos();

                        // obtengo datos para indicador
                        $scope.getRecibosEstados();
                }, function () {
                    // si hay dismissed no hago reload
                }); 

        };

    }
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.reset')
    .controller('ResetPageCtrl', ResetPageCtrl);

  /** @ngInject */
  function ResetPageCtrl($scope, $http, md5, SELFS_CONFIG, $stateParams, $location) {

    $scope.actualizada = false;

    $scope.passwordActualizada = function () {
      return $scope.actualizada;
    }

    $scope.volver = function () {
      $location.path('/login');
    }

    $scope.cambiarPassword = function () {
      // ejecuto el cambio si es válido y si no es undefined o vacío 
      
      if ($scope.resetForm.inputPassword.$valid && $scope.inputPassword != undefined && $scope.inputPassword != '') {        
        $http({
          method: 'PUT', url: SELFS_CONFIG.url + '/reset/' + $stateParams.token,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          },
          data: { "new-password": md5.createHash($scope.inputConfirmPassword || '') }
        })
          .then(function (response) {
            $scope.actualizada = true;
          });
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('SelfService.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

(function () {
  'use strict';

  angular.module('SelfService.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
  'use strict';


  angular.module('SelfService.pages.capacitaciones')
    .directive('enter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            event.preventDefault();
            var fields = $(this).parents('form:eq(0),body').find('input, textarea, select');
            var index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length)
              fields.eq(index + 1).focus();
          }
        });
      };
    });



  angular.module('SelfService.pages.capacitaciones')
    .controller('capacitacionesPageCtrl', CapacitacionesPageCtrl);


  function CapacitacionesPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG) {
       
    // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
    $scope.itemsByPage=5;

    $scope.getCapacitaciones = function() {
      // Llamada a datos de Tickets
      $http({method: 'GET', url: SELFS_CONFIG.url + '/cursos/aprobados'})
      .success( function(data) {
        $scope.capacitacionsCollection = data;
      })
      .error( function(data, status, headers, config) {
          toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
      });
    }    

    $scope.getCapacitacionesSolicitadas = function() {
      $http({method: 'GET', url: SELFS_CONFIG.url + '/cursos/solicitados'})
      .success( function(solicitados) {
        $scope.capacitacionSolicitadas = solicitados;
      })
      .error( function(solicitados, status, headers, config) {
          toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
      });
    }    
    $scope.getCapacitaciones();
    $scope.getCapacitacionesSolicitadas();
    $scope.refresh = function(){
        $scope.getCapacitaciones();
    }

  }
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */

  function BlurFeedCtrl($scope, $http, $localStorage, SELFS_CONFIG) {
    $scope.novedades = [];
    $scope.logoCartelera = 'logoCartelera';
    $scope.itemsByPage=5;
    
    $scope.getNovedades = function(){
      $http({method: 'GET', url: SELFS_CONFIG.url + '/novedades'})
         .success( function(data) {
           $scope.novedades = data; 

           if($scope.novedades.length == 0){
             $scope.novedades =  $scope.mensajeVacio;
           } 
          });
    }
    
    $scope.getNovedades();

    //HDY: setInterval es una función propia de angular para realizar llamadas al backend cada n cantidad de tiempo (milisegundos)
    $scope.mensajeVacio = [
        {         
          titulo: 'Bienvenidos al sitio de selfservice',
          descripcion: 'Usted a través del portal podrá actualizar sus datos personales, familiares, solicitar licencias, subir certificados y descargar sus recibos de sueldo y formularios de ganancias. Le pedimos por favor que cambie su contraseña desde la configuración del perfil de usuario.',
          expanded: true
        }  
      ]; 

      $scope.expandMessage = function(message){
        message.expanded = !message.expanded;
      }
  }
})();
(function () {
  'use strict';

  angular.module('SelfService.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('SelfService.pages.familiares').controller('familiaresModalCtrl', familiaresModalCtrl);
    function familiaresModalCtrl($scope, $http, toastr, toastrConfig, parametroUrl, SELFS_CONFIG) {

        $scope.familiaresModalData = [];

        $scope.nacionalidadesBase = [];

        // close y dismiss de modal
        $scope.closeModal = function(){
            $scope.$close();
        };

        $scope.dismissModal = function(){
            $scope.$dismiss();
        };
        
        //LLAMADA PARA CARGAR LOS SELECTS
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/nacionalidades' })
        .success(function (traerNacionalidades) {
            $scope.nacionalidadesBase = traerNacionalidades;
        })
        .error(function (traerNacionalidades, status, headers, config) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

        $scope.estadosCivilesBase = [];

        //LLAMADA PARA CARGAR LOS SELECTS
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/valores/tipos-estado-civil' })
        .success(function (traerEstadosCiviles) {
            $scope.estadosCivilesBase = traerEstadosCiviles;
        })
        .error(function (traerEstadosCiviles, status, headers, config) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
        //FIN SELECTS

        var l_url = parametroUrl.getParametro();
        
        $http({ method: 'GET', url: l_url})        
            .success(function (data) {
                $scope.familiaresModalData = data;  

                $scope.datePickerFnacim = {};
                if (typeof data.fnacim === '' || !data.fnacim || data.fnacim === '01/01/0001') {
                    $scope.datePickerFnacim = '';
                    $scope.familiaresModalData.fnacim = null;
                }else{
                    var castFnacim = moment(data.fnacim, 'DD/MM/YYYY');
                    $scope.datePickerFnacim = castFnacim;
                }

                $scope.datePickerFcasam = {};
                //Evaluo el valor de data.fcasam que viene del json.  
                //Si la fecha viene null, vacia o con string 01/01/0001 (valor que pone el datepicker por defecto) al ng-model del calendario le paso un valor vacio
                if (typeof data.fcasam === '' || !data.fcasam || data.fcasam === '01/01/0001') {
                    $scope.datePickerFcasam = '';                    
                    $scope.familiaresModalData.fcasam = null;
                }else{
                    //Sino casteo el string a un date con moment.js 
                    var castFcasam = moment(data.fcasam, 'DD/MM/YYYY');
                    $scope.datePickerFcasam = castFcasam;
                }
            })
            .error(function (data, status, headers, config) {
                toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
            });
        
        $scope.actualizarFamiliar = function () {
            var data = {     
                        "emp": $scope.familiaresModalData.emp,      
                        "legajo": $scope.familiaresModalData.legajo,                
                        "nombre": $scope.familiaresModalData.nombre,
                        "fnacim":$scope.familiaresModalData.fnacim,
                        "sexo": $scope.familiaresModalData.sexo,
                        "codnac": $scope.familiaresModalData.codnac,
                        "fcasam": $scope.familiaresModalData.fcasam,                        
                        "ecivil": $scope.familiaresModalData.ecivil                                     
                        }

             var l_url = parametroUrl.getParametro();


             $http({ method: 'PUT', url: l_url, data: JSON.stringify(data) })
             .success( function(response) { 
                    
                    toastr.success('', 'Los datos se actualizaron correctamente.', {
                    "autoDismiss": false,
                    "positionClass": "toast-top-left",
                    "type": "success",
                    "timeOut": "3000",
                    "extendedTimeOut": "1000",
                    "allowHtml": false,
                    "closeButton": true,
                    "tapToDismiss": true,
                    "progressBar": false,
                    "newestOnTop": true,
                    "maxOpened": 0,
                    "preventDuplicates": false,
                    "preventOpenDuplicates": false
                    });
                    
                    $scope.closeModal();
             }) 
             .error( function(response, status, headers, config) {
              
                    toastr.error('Código de error: ' + status , 'Falló la actualización de datos.', {
                    "autoDismiss": false,
                    "positionClass": "toast-top-left",
                    "type": "error",
                    "timeOut": "3000",
                    "extendedTimeOut": "1000",
                    "allowHtml": false,
                    "closeButton": true,
                    "tapToDismiss": true,
                    "progressBar": false,
                    "newestOnTop": true,
                    "maxOpened": 0,
                    "preventDuplicates": false,
                    "preventOpenDuplicates": false
                    });
                   $scope.dismissModal();
             });
        }

        //Datepickers
        $scope.onChangeDateFnacim = function (newValue) {

            if (typeof newValue === 'undefined' || !newValue) {
                $scope.familiaresModalData.fnacim = null;
            }else{
                $scope.newFnacim = newValue;
                var castDatePicker = moment($scope.newFnacim).format('DD/MM/YYYY');
                $scope.familiaresModalData.fnacim = castDatePicker;  
            }


        };

        $scope.onChangeDateFcasam = function (newValue) {
            
            if (typeof newValue === 'undefined' || !newValue) {
                $scope.familiaresModalData.fcasam = null;
            }else{
                $scope.newFcasam = newValue;
                var castDatePicker = moment($scope.newFcasam).format('DD/MM/YYYY');
                $scope.familiaresModalData.fcasam = castDatePicker;  
            }
        };
    }
 
})();   
(function () {
  'use strict';


  angular.module('SelfService.pages.licencias')
    .directive('enter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            event.preventDefault();
            var fields = $(this).parents('form:eq(0),body').find('input, textarea, select');
            var index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length)
              fields.eq(index + 1).focus();
          }
        });
      };
    });



  angular.module('SelfService.pages.licencias')
    .controller('SolicitarLicenciasPageCtrl', SolicitarLicenciasPageCtrl);


  function SolicitarLicenciasPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG) {

    // TOKEN DE SEGURIDAD PARA EL LOGIN 
    if (!$localStorage.user.token) {
      $location.path('/login');
    }

    
    $scope.licencias = {};
    $scope.licenciasDetalle = [];
    // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
    $scope.itemsByPage = 5;

    $scope.openModalLicencias = function (item) {
      $scope.licenciasDetalle = [];

      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/detalle/' + item.periodo })
        .success(function (data) {
          $scope.licenciasDetalle = data;

          var licenciasModal = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/licencias/modals/licenciasModal.html',
            size: 'lg',
            controller: 'licenciasModalCtrl',
            resolve: {
              licenciasDetalle: function () {
                return $scope.licenciasDetalle;
              }
            }
          });
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    };

    $scope.openModalReciboLicencias = function () {
      $scope.recibosDetalle = {};

      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/recibos' })
        .success(function (data) {
          $scope.recibosDetalle = data;

          if ($scope.recibosDetalle != null && $scope.recibosDetalle != "") {

            var reciboLicenciasModal = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/licencias/modals/recibosLicenciasModal.html',
              size: 'lg',
              controller: 'recibosLicenciasModal',
              resolve: {
                recibosDetalle: function () {
                  return $scope.recibosDetalle;
                }
              }
            })
          } else {
            toastr.error('No hay notificaciones para mostrar.');
          }

        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    };

    // HDY: SOLICITA UNA NOVEDAD DE LICENCIA
    $scope.enviarSolicitudLic = function () {

      // DECLARACION DE VARIABLES.
      var codnov = $scope.licencias.codnov;
      var ANIO_INICIO_SS = 6;
      var ANIO_FIN_SS = 10;
      var LIC_ESTUDIO = 1;
      var LIC_ENFERMEDAD = 2;
      var LIC_MATERNIDAD = 3;
      var LIC_HORA_EXTRA_50 = 4;
      var LIC_HORA_EXTRA_100 = 5;
      var anio = $scope.licencias.fsalida.substring(ANIO_INICIO_SS, ANIO_FIN_SS);
      
      var keepGoing = true;

      // UNIDAD Y FECHA SON LOS PARAMETROS QUE SE INGRESAN POR INPUT
      var unidad = $scope.licencias.unidad || ($scope.licencias.horas + $scope.licencias.minutos * 0.01);
      var fecha = $scope.licencias.fsalida;

      // HDY: GET PARA OBTENER VALIDACIÓN DE TOPES DE LICENCIA
      if(unidad != 0) {
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/topes/' + $scope.licencias.codnov })
        .success(function (tope) {
          //VALIDO TOPE DE LA NOVEDAD
          if(tope.length != 0){
          //ACLARACIÓN SI(HEXTRAS == 'S') ENTONCES NO SE VALIDAN TOPES DE HORAS EXTRAS 
          if ((unidad <= tope.topenov  || $scope.pedirLicencias[$scope.licencias.codnov-1].hextras == 'S') && unidad > 0) {
            // HDY: GET PARA OBTENER VALIDACIÓN DE TOPES DE LICENCIA ANUAL
            $http({ method: 'GET', url: SELFS_CONFIG.url + '/acumulador_licencia/' + codnov + '/' + anio })
              .success(function (licencia_anual_acum) {
                // VALIDO TOPE HASTA ANUAL
                //ACLARACIÓN SI(HEXTRAS == 'S') ENTONCES NO SE VALIDAN TOPES ANUALES DE HORAS EXTRAS 
                if (licencia_anual_acum.length < tope.topeanu || $scope.pedirLicencias[$scope.licencias.codnov-1].hextras == 'S') {
                  // OBTENGO TODAS LAS LICENCIAS APROBADAS DEL USUARIO LOGUEADO
                  $http({ method: 'GET', url: SELFS_CONFIG.url + '/validacion_licencia/solapamiento_novedades' })
                    .success(function (data) {
                      var data_length = data.length;
                      // VALIDO SI EXISTE SOLAPAMIENTO DE UNA NOVEDAD DE LINCENCIA INGRESADA CONTRA NOVEDADES DE LICENCIA APROBADAS
                      for (var i = 0; i < unidad; i++) {
                        // MOMENT LA USAMOS PARA RECORRER LAS FECHAS.
                        var nfs = moment(fecha, "DD/MM/YYYY").add(i, 'days').format("DD/MM/YYYY");
                        for (var x = 0; x < data_length; x++) {
                          for (var z = 0; z < data[x].unidad; z++) {
                            // KEEPGOING LA USAMOS PARA VERIFICAR QUE LA FECHA YA NO PUEDE SER INGRESADA Y NOS AHORRAMOS CICLOS EXTRAS DE EJECUCION.
                            if (keepGoing) {
                              var nfr = moment(data[x].fsalida, "DD/MM/YYYY").add(z, 'days').format("DD/MM/YYYY");
                              if (nfs == nfr) {
                                // VALIDO EL INGRESO DE HORAS EXTRAS CON OTRAS HORAS EXTRAS
                                if (($scope.licencias.codnov == LIC_HORA_EXTRA_50 || $scope.licencias.codnov == LIC_HORA_EXTRA_100) &&
                                  (data[x].codnov == LIC_HORA_EXTRA_50 || data[x].codnov == LIC_HORA_EXTRA_100)) {
                                  keepGoing = false;
                                  toastr.error('La fecha seleccionada está ocupada por horas extras.');
                                }
                                // VALIDO EL INGRESO DE NOVEDADES DE LICENCIA CON OTRAS NOVEDADES DE LICENCIA.
                                if (($scope.licencias.codnov == LIC_ESTUDIO || $scope.licencias.codnov == LIC_ENFERMEDAD || $scope.licencias.codnov == LIC_MATERNIDAD) &&
                                  (data[x].codnov == LIC_ESTUDIO || data[x].codnov == LIC_ENFERMEDAD || data[x].codnov == LIC_MATERNIDAD)) {
                                  keepGoing = false;
                                  toastr.error('La fecha seleccionada está ocupada por una novedad de licencia.');
                                }
                              }
                            }

                          }

                        }

                      }
                      // KEEPGOING ES UNA BANDERA QUE VALIDA EL SOLAPAMIENTO, EN CASO DE EXISTIR UNA NOVEDAD INGRESADA EN ESA FECHA.
                      if (keepGoing == true) {
                        // REALIZO POST DE LA NOVEDAD DE LICENCIA
                        $http({
                          method: 'POST', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos',
                          data: {
                            "emp": $localStorage.user.emp,
                            "legajo": $localStorage.user.legajo,
                            "codnov": codnov,
                            "unidad": unidad,
                            "fsalida": fecha,
                            "comentario": $scope.licencias.observaciones
                          }
                        })
                          .success(function (response) {
                            $scope.refresh();
                            var castanio = moment(fecha,"DD/MM/YYYY").year();
                            $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/suma/'+ codnov +'/' + castanio })
                            .success(function (data) {
                              var sumaSolicitadas = data;
                              $http({ method: 'GET', url: SELFS_CONFIG.url + '/topes/' + codnov })
                              .success(function (tope) {
                                var topeConfigurado = tope.topeanu;
                                if(topeConfigurado < sumaSolicitadas){
                                  toastr.warning('Los días de la novedad superan el tope acumulado.',{timeOut: 0, extendedTimeOut: 0 });
                                }
                            })
                            })      


                            toastr.success('', 'Se ha enviado su solicitud de licencias.');
                            // LUEGO DEL POST BLANQUEO LOS VARIABLES DEL FRONT 
                            $scope.licencias.codnov = "";
                            $scope.licencias.fsalida = "";
                            $scope.licencias.fsalida1 = "";
                            $scope.licencias.unidad = "";
                            $scope.licencias.horas = "";
                            $scope.licencias.minutos = "";
                            $scope.licencias.observaciones = "";
                          })
                          .error(function (status) {
                            toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
                          });
                      }
                    })
                    .error(function (status) {
                      toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
                    });
                } else {
                  $scope.validoDia();
                  toastr.error('', 'La licencia solicitada supera el tope anual configurado.');
                };
              })
              // CIERRO ERROR DE VALIDACION ANUAL
              .error(function (status) {
                toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
              });
          } else {
            toastr.error('', 'La cantidad solicitada es incorrecta revise el tope configurado.');
          };
        } else {
            toastr.error('', 'La novedad no tiene topes configurados.');
          };
          // CIERRO ERROR DEL TOPE 
        }).error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    } else {
      toastr.error('Completar campos de horas o minutos.');
    }
  }

    // HDY: Código para obtner el sysdate. $scope.min = moment();
    // HDY: Variable que usa el datepicker para definir la fecha-desde en html. Se debe utilizar el tag < min-date="min" >
    var fechaTopeSolicitar = 21;
    $scope.min = moment().subtract(fechaTopeSolicitar, 'days');

    // Función para los Datepickers
    $scope.onChangeDateFlic = function (newValue) {

      if (typeof newValue === 'undefined' || !newValue) {
        $scope.licencias.fsalida = null;
      } else {
        $scope.newFlic = newValue;
        var castDatePicker = moment($scope.newFlic).format('DD/MM/YYYY');
        $scope.licencias.fsalida = castDatePicker;
      }
    };

    $scope.validoDia = function () {
      $scope.licencias.unidad = "";
      $scope.licencias.horas = "";
      $scope.licencias.minutos = "";
    }
    // FUNCIÓN PARA ELIMINAR LA LICENCIA INGRESADA.
    $scope.onDelete = function (item) {

      // METODO PARA OBTENER LOS PEDIDOS INGRESADOS POR ID
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados/' + item.id })
        .success(function (data) {
          // PREGUNTO SI EL ESTADO ES INGRESADO PARA HACER EL DELETE DE LA LICENCIA
          if (data.estado == "I") {
            $http({
              method: 'PUT', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados/eliminar/' + item.id,
              data: angular.toJson(item)
            })
              .success(function (response) {
                $scope.refresh()
                toastr.success('', 'La licencia solicitada se eliminó correctamente.');
              })
              .error(function (response, status, headers, config) {
                $scope.refresh()
                toastr.error('', 'Error la licencia a eliminar ya ha sido modificada.');
              });
            // SI EL ESTADO FUE MODIFICADO POR LA PERSONA A CARGO VA A DEVOLVER UN MENSAJE DE ERROR
          } else if (data.estado == "P" || data.estado == "A") {
            $scope.refresh()
            toastr.error('', 'Error la licencia a eliminar ya se encuentra aprobada.');
          } else if (data.estado == "R") {
            $scope.refresh()
            toastr.error('', 'Error la licencia a eliminar ya se encuentra rechazada.');
          }
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    };


    // Filtros por Pais
    $scope.filterPorPais = function (pais) {
      return function (item) {
        if (item.pais == pais) {
          return true;
        }
        return false;
      };
    };

    //SELECTS 
    $scope.tablaLicencias = [];

    // LLAMADA PARA CARGAR LAS LICENCIAS SOLICITADAS
    $scope.licenciasSolicitadas = [];
    $scope.getLicenciasSolicitadas = function () {
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos' })
        .success(function (data) {
          $scope.licenciasSolicitadas = data;
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    }


    // LLAMADA PARA TRAER LOS DATOS DEL SELECT DE LICENCIA.
    $scope.pedirLicencias = [];
    $scope.getpedirLicencias = function () {
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/codigos' })
        .success(function (data) {
          $scope.pedirLicencias = data;
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    }

    $scope.licencia = [];

    $scope.refresh = function () {
      $scope.getLicenciasSolicitadas();
      $scope.getpedirLicencias();
    }
    
    $scope.refresh()




  }
})();

(function () {
    'use strict';

    angular.module('SelfService.pages.login') 
    .controller('elegirEmpresaModalCtrl', elegirEmpresaModalCtrl);    
    
    function elegirEmpresaModalCtrl($scope, $http, items) { 

        $scope.empresas = items.empresas;  

        $scope.empresa = $scope.empresas[0];
        
        // close y dismiss de modal
        $scope.closeModal = function(){
           $scope.$close($scope.empresa);
        };

        $scope.dismissModal = function(){
            $scope.$dismiss();
        };       
    }
})();
(function () {
  'use strict';

  angular.module('SelfService.pages.recibos')
      .controller('firmarRecibosDiscModalCtrl', firmarRecibosDiscModalCtrl);

  /** @ngInject */
  function firmarRecibosDiscModalCtrl($scope, $location, $localStorage) {
   $scope.motivoDisconformidad = '';

   if (!$localStorage.user.token) {
     $location.path('/login');
   }
    
    $scope.firmarReciboDisconforme = function () {
       $scope.$close($scope.motivoDisconformidad);
    }

}
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.recibos')
    .controller('firmarRecibosModalCtrl',firmarRecibosModalCtrl);
    function firmarRecibosModalCtrl($scope, $location, $localStorage, SELFS_CONFIG, $http, toastr, toastrConfig, $sce, $uibModal, recibo) {

    if (!$localStorage.user.token) {
      $location.path('/login');
    }
    $scope.item = recibo;

       $scope.pdfSoporta = true;
       var isIE = /*@cc_on!@*/false || !!document.documentMode;

       if (isIE){  
              $scope.pdfSoporta = false;
        }
        else if(PDFObject.supportsPDFs){
            $http({ method: 'GET', url: SELFS_CONFIG.url + '/recibos/' + $scope.item.renglon }, { responseType: 'arraybuffer' })
              .success(function (response) {

                var file = new Blob([response], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);

                $scope.content = $sce.trustAsResourceUrl(fileURL);
                
                PDFObject.embed(fileURL, "#pdfcontainerdiv");
              })
              .error(function (status) {
                toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
              });
        } else {
             $scope.pdfSoporta = false;
             console.log("El navegador no soporta visualizar archivos PDFs.");
        }

    $scope.firmarRecibo = function () {
      $http({
        method: 'POST', url: SELFS_CONFIG.url + '/recibos/' + $scope.item.renglon + '/firmados-digital',
        data: {
          "edigital": "F"
        }
      })
        .success(function (response) {
          toastr.success('', 'Se firmó en conformidad el recibo.');
          $scope.$close();
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
          $scope.$dismiss();
        });
    }

    $scope.firmarReciboDisconforme = function (motivoDisconformidad) {

          var data = {     
                        "edigital": "D",
                        "observaciones": motivoDisconformidad,      
                      }

          $http({
            method: 'POST', url: SELFS_CONFIG.url + '/recibos/' + $scope.item.renglon + '/firmados-digital',  data: JSON.stringify(data) })  
            .success(function (response) {
              toastr.success('', 'Se firmó no conforme el recibo.');
              $scope.$close();
            })
            .error(function (status) {
              toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
              $scope.$dismiss();
            });
        }

      //LLAMADA DEL MODAL FIRMAR RECIBOS 
        $scope.openModalFirmaDisconformidad = function (renglon) {
           var modalFirmaDisconformidad = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/recibos/modals/firmarRecibosDiscModal.html',
                size: 'lg',
                controller: 'firmarRecibosDiscModalCtrl'
            });

            modalFirmaDisconformidad.result.then(function (motivo) {
                        // obtengo lista de recibos
                        $scope.firmarReciboDisconforme(motivo);
                }, function () {
                    // si hay dismissed no hago reload
                }); 

        };   
    };
})();


(function () {
    'use strict';


    angular.module('SelfService.pages.supervisor.equipotrabajo')
        .controller('EquipotrabajoPageCtrl', EquipotrabajoPageCtrl);

    /** @ngInject */
    function EquipotrabajoPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG, parametroUrle) {

        //TOKEN DE SEGURIDAD PARA EL LOGIN 
        if (!$localStorage.user.token) {
            $location.path('/login');
        }
        $scope.rol = $localStorage.user.rol;
        // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
        $scope.itemsByPage=12;
        if ($scope.rol == 'ADMIN') {


            $scope.equipoTrabajo = [];
            $scope.getEquipoTrabajo = function () {
                $http({ method: 'GET', url: SELFS_CONFIG.url + '/subordinados' })
                    .success(function (data) {
                        $scope.equipoTrabajo = data;
                    })
                    .error(function (status) {
                        toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
                    });

            }
            
            $scope.getEquipoTrabajo();
            $scope.refresh = function () {
                $scope.getEquipoTrabajo();
            }

            $scope.set_color = function (nivel1) {
                
                if (nivel1%2 == 0) {
                    return { "background-color": "#FCEDED" };
                } else {
                    return { "background-color": "#FcF7F7" };
                }
            };

            $scope.openModalLegajo = function (legajo) {
                parametroUrle.setParametro(legajo);
                var legajoModal = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/supervisor/equipotrabajo/modals/legajoModal.html',
                    controller: 'legajoModalCtrl',
                    resolve: {
                        item: function () {
                            return $scope.item;
                        }
                    }
                });
                legajoModal.result.then(function () {
                    $scope.getEquipoTrabajo();
                }, function () {

                });
            }


        }
    }


})();
angular.module('SelfService.pages.supervisor.equipotrabajo').factory("parametroUrle", function(SELFS_CONFIG){
    this.l_urle = ''; 

    this.setParametro = function(legajo) {
      
        this.l_urle = SELFS_CONFIG.url + "/subordinados/" + legajo;
    };       

    this.getParametro = function() {
        return this.l_urle;
    };
    return {
        getParametro: this.getParametro,
        setParametro: this.setParametro
    };
});
(function () {
  'use strict';

  angular.module('SelfService.pages.supervisor')
    .controller('rechazoLicModalCtrl', rechazoLicModalCtrl);

  /** @ngInject */
  function rechazoLicModalCtrl($scope, $location, $localStorage, $http, toastr, toastrConfig, SELFS_CONFIG, estadolic, idlic, emp, legajo, codnov, desccodnov, unidad, fsalida, descestado, comentario, nombre) {

    if (!$localStorage.user.token) {
      $location.path('/login');
    }

    // close y dismiss de modal
    $scope.closeModal = function () {
      $scope.$close();
    };

    $scope.dismissModal = function () {
      $scope.$dismiss();
    };

    // Actualiza el estado de la Licencia 
    $scope.actualizarLicenciaSolRec = function (comentariorec) {
      // SI LA LICENCIA SOLICITADA NO TENIA COMENTARIO EL COMENTARIO VA A ESTAR VACIO
      if(comentario == null) {
        comentario = "";
      }

      // SI EL RECHAZO NO TIENE COMENTARIO ENTONCES EL COMENTARIO VA A ESTAR VACIO
      if(comentariorec != undefined) {
        comentariorec = ',  Motivo de rechazo: ' + comentariorec;
      } else {
        comentariorec = "";
      }

      var data =
      {
        "id": idlic,
        "emp": emp,
        "legajo": legajo,
        "codnov": codnov,
        "desccodnov": desccodnov,
        "unidad": unidad,
        "fsalida": fsalida,
        "estado": estadolic,
        "descestado": descestado,
        "comentario": comentario + comentariorec,
        "nombre": nombre
      }

      $http({
        method: 'PUT', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados/' + idlic,
        data: JSON.stringify(data)
      })
        .success(function (response) {

          toastr.success('', 'Los datos se actualizaron correctamente.', {
            "autoDismiss": false,
            "positionClass": "toast-top-left",
            "type": "success",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": true,
            "progressBar": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
          });

          $scope.closeModal();
        })
        .error(function (response, status, headers, config) {
          toastr.error('Código de error: ' + status, 'Falló la actualización de datos.', {
            "autoDismiss": false,
            "positionClass": "toast-top-left",
            "type": "error",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": true,
            "progressBar": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
          });
          $scope.dismissModal();
        });
 
    }

  }
})();
(function () {
  'use strict';

  angular.module('SelfService.pages.supervisor')
    .controller('rechazoVacModalCtrl', rechazoVacModalCtrl);

  /** @ngInject */
  function rechazoVacModalCtrl($scope, $location, $localStorage, $http, toastr, toastrConfig, SELFS_CONFIG, estadovac, idvac, emp, legajo, dias, fsalida, descestado, comentario, nombre) {

    if (!$localStorage.user.token) {
      $location.path('/login');
    }

    // CIERRA Y DESPIDE AL MODAL.
    $scope.closeModal = function () {
      $scope.$close();
    };

    $scope.dismissModal = function () {
      $scope.$dismiss();
    };

    // ACTUALIZA EL ESTADO DE LAS VACACIONES. 
    $scope.actualizarVacacionSolRec = function (comentariorec) {
      // SI LA LICENCIA SOLICITADA NO TENIA COMENTARIO EL COMENTARIO VA A ESTAR VACIO
      if(comentario == null) {
        comentario = "";
      }

      // SI EL RECHAZO NO TIENE COMENTARIO ENTONCES EL COMENTARIO VA A ESTAR VACIO   
      if(comentariorec != undefined) {
        comentariorec = ',  Motivo de rechazo: ' + comentariorec;
      } else {
        comentariorec = "";
      }

      var data =
      {
        "id": idvac,
        "emp": emp,
        "legajo": legajo,
        "dias": dias,
        "fsalida": fsalida,
        "estado": estadovac,
        "descestado": descestado,
        "comentario": comentario + comentariorec,
        "nombre": nombre
      }
      $http({
        method: 'PUT', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados/' + idvac,
        data: JSON.stringify(data)
      })
        .success(function (response) {

          toastr.success('', 'Los datos se actualizaron correctamente.', {
            "autoDismiss": false,
            "positionClass": "toast-top-left",
            "type": "success",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": true,
            "progressBar": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
          });

          $scope.closeModal();
        })
        .error(function (response, status, headers, config) {
          toastr.error('Código de error: ' + status, 'Falló la actualización de datos.', {
            "autoDismiss": false,
            "positionClass": "toast-top-left",
            "type": "error",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": true,
            "progressBar": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
          });
          $scope.dismissModal();
        });
 
    }

  }
})();

(function () {
  'use strict';


  angular.module('SelfService.pages.supervisor.novedadespersonal')
    .controller('NovedadespersonalPageCtrl', NovedadespersonalPageCtrl);

  /** @ngInject */
  function NovedadespersonalPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG, calendarConfig, moment, $timeout) {

    // DECLARACION DE VARIABLES PRINCIPALES.
    $scope.licenciasperActualizadas = [];
    $scope.licenciasperSolicitadas = [];
    $scope.itemsByPage = 5;
    $scope.loading = true;

    //TOKEN DE SEGURIDAD PARA EL LOGIN 
    if (!$localStorage.user.token) {
      $location.path('/login');
    }
    $scope.rol = $localStorage.user.rol;

    if ($scope.rol == 'ADMIN') {

      //LLAMADA PARA CARGAR PARAMETRO 942      
      $scope.par942 = [];
      $scope.getPar942 = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/parametros/' + $scope.emp + '/942' })
          .success(function (datap) {
            $scope.parchar942 = datap.parChar;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }
      $scope.getPar942();
      $scope.refresh = function () {
        $scope.getPar942();
      }

      // LLAMADA PARA CARGAR LAS LICENCIAS Y VACACIONES POR EL PERSONAL A CARGO.
      $scope.getLicenciasVacacionesPerSolicitadas = function () {

        //LLAMADA PARA CARGAR LAS LICENCIAS SOLICITADAS POR EL PERSONAL A CARGO. 
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados' })
          .success(function (data) {
            $scope.licenciasperSolicitadas = $scope.licenciasperSolicitadas.concat(data)
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

        //LLAMADA PARA CARGAR LAS VACACIONES SOLICITADAS POR EL PERSONAL A CARGO.
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados' })
          .success(function (data) {
            $scope.licenciasperSolicitadas = $scope.licenciasperSolicitadas.concat(data)
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });
      }

      // LLAMADA PARA CARGAR LAS LICENCIAS Y VACACIONES ACTUALIZADAS POR EL PERSONAL A CARGO.
      $scope.getLicenciasVacacionesPerActualizadas = function () {

        // LLAMADA PARA CARGAR LAS LICENCIAS SOLICITADAS POR EL PERSONAL A CARGO.
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/actualizados' })
          .success(function (data1) {
            $scope.licenciasperActualizadas = $scope.licenciasperActualizadas.concat(data1);
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

        // LLAMADA PARA CARGAR LAS VACACIONES SOLICITADAS POR EL PERSONAL A CARGO.
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados' })
          .success(function (data2) {
            $scope.licenciasperActualizadas = $scope.licenciasperActualizadas.concat(data2);
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });
      }

      $scope.refresh = function () {
        $scope.licenciasperSolicitadas = [];
        $scope.licenciasperActualizadas = [];
        $scope.getLicenciasVacacionesPerSolicitadas();
        $scope.getLicenciasVacacionesPerActualizadas();
        $scope.cargarEventos();
      }

      // ACTUALIZO EL ESTADO DE LA LICENCIA SOLICITADA.
      $scope.actualizarLicenciaSol = function (estadolic, idlic, emp, legajo, codnov, desccodnov, unidad, fsalida, descestado, comentario, nombre) {
        var data =
        {
          "id": idlic,
          "emp": emp,
          "legajo": legajo,
          "codnov": codnov,
          "desccodnov": desccodnov,
          "unidad": unidad,
          "fsalida": fsalida,
          "estado": estadolic,
          "descestado": descestado,
          "comentario": comentario,
          "nombre": nombre
        }

        $http({
          method: 'PUT', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados/' + idlic,
          data: JSON.stringify(data)
        })
          .success(function (response) {
            $scope.refresh();
            toastr.success('', 'Los datos se actualizaron correctamente.');
          })
          .error(function (response, status, headers, config) {
            toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
          });

      }

      // ACTUALIZO EL ESTADO DE LAS VACACIONES SOLICITADAS. 
      $scope.actualizarVacacionesSol = function (estadovac, idvac, emp, legajo, dias, fsalida, descestado, comentario, nombre) {
        var data =
        {
          "id": idvac,
          "emp": emp,
          "legajo": legajo,
          "dias": dias,
          "fsalida": fsalida,
          "estado": estadovac,
          "descestado": descestado,
          "comentario": comentario,
          "nombre": nombre
        }

        $http({
          method: 'PUT', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados/' + idvac,
          data: JSON.stringify(data)
        })
          .success(function (response) {
            $scope.refresh();
            if(estadovac == 'P') {
              toastr.success('', 'Pedido Preaprobado correctamente.');
            } else {
              toastr.success('', 'Pedido Anulado correctamente.');
            }

          })
          .error(function (response, status, headers, config) {
            toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
          });

      }

      // LLAMADA AL MODAL PARA RECHAZAR LA LICENCIA.
      $scope.openModalRechazoLic = function (estadolic, idlic, emp, legajo, codnov, desccodnov, unidad, fsalida, descestado, comentario, nombre) {

        var reachazoLicModal = $uibModal.open({
          animation: true,
          templateUrl: 'app/pages/supervisor/modals/rechazoLicModal.html',
          controller: 'rechazoLicModalCtrl',

          resolve: {

            estadolic: function () {
              return estadolic;
            },
            idlic: function () {
              return idlic;
            },
            emp: function () {
              return emp;
            },
            legajo: function () {
              return legajo;
            },
            codnov: function () {
              return codnov;
            },
            desccodnov: function () {
              return desccodnov;
            },
            unidad: function () {
              return unidad;
            },
            fsalida: function () {
              return fsalida;
            },
            descestado: function () {
              return descestado;
            },
            comentario: function () {
              return comentario;
            },
            nombre: function () {
              return nombre;
            }

          }

        });

        reachazoLicModal.result.then(function () {
          // reload
          $scope.refresh();
        });

      }

      // LLAMADA AL MODAL PARA RECHAZAR LAS VACACIONES.
      $scope.openModalRechazoVac = function (estadovac, idvac, emp, legajo, dias, fsalida, descestado, comentario, nombre) {
        var reachazoVacModal = $uibModal.open({
          animation: true,
          templateUrl: 'app/pages/supervisor/modals/rechazoVacModal.html',
          controller: 'rechazoVacModalCtrl',

          // LOS PARAMETROS QUE LE PASO AL MODAL.
          resolve: {
            estadovac: function () {
              return estadovac;
            },
            idvac: function () {
              return idvac;
            },
            emp: function () {
              return emp;
            },
            legajo: function () {
              return legajo;
            },
            dias: function () {
              return dias;
            },
            fsalida: function () {
              return fsalida;
            },
            descestado: function () {
              return descestado;
            },
            comentario: function () {
              return comentario;
            },
            nombre: function () {
              return nombre;
            }
          }

        });

        reachazoVacModal.result.then(function () {
          // reload
          $scope.refresh();
        });

      }

      // DESDE ACA VIENE EL CALENDARIO + info: https://mattlewis92.github.io/angular-bootstrap-calendar/#
      // VARIABLE PARA DEFINIR EL INICIO DEL CALENDARIO (MONTH, YEAR, DAY), NECESARIAS PARA EL FUNCIONAMIENTO DEL CALENDAR.
      $scope.calendarView = 'month';
      $scope.viewDate = new Date();
      // VARIABLES PARA DEFINIR IDIOMA.
      moment.locale('es');
      calendarConfig.dateFormatter = 'moment';
      calendarConfig.i18nStrings.weekNumber = '{week}';

      // EVENTS SIRVE PARA MOSTRAR ACCIONES DE LAS NOVEDADES DE LICENCIA DE SUS PERSONAS A CARGO.
      $scope.events = [];

      // VARIABLE PARA DEFINIR SI EL SLIDE DE CONTENIDO DEL CALENDARIO COMIENZA ABIERTO O CERRADO(TRUE O FALSE)
      $scope.cellIsOpen = false;

      // SE CARGAN TODAS LAS VACACIONES Y LICENCIAS DEL EMPLEADO A CARGO EN EL CALENDARIO.
      $scope.cargarEventos = function () {
        // AGARRO TODAS LAS LICENCIAS DEL EMPLEADO A CARGO.
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/actualizados' })
          .success(function (data) {
            for (var x = 0; x < data.length; x++) {

              // ASIGNO EL COLOR DEL EVENTO DEPENDIENDO DEL ESTADO DE LA SOLICITUD.
              if (data[x].estado == 'I') { //ESTADO INGRESADO
                var color_calendario = calendarConfig.colorTypes.warning
              } if (data[x].estado == 'P') { //ESTADO PREAPROBADO
                var color_calendario = calendarConfig.colorTypes.info
              } if (data[x].estado == 'A') { //ESTADO APROBADO
                var color_calendario = calendarConfig.colorTypes.success
              } if (data[x].estado == 'R' || data[x].estado == 'X') { //ESTADO RECHAZADO O ANULADO
                var color_calendario = calendarConfig.colorTypes.important
              }

              // INGRESO LAS SOLICITUDES EN EVENTS[X]
              $scope.events[x] = {
                title: data[x].nombre + ' - ' + data[x].desccodnov + ' - Fecha desde: ' + data[x].fsalida + ' - Días: ' + data[x].unidad + ' - Estado: ' + data[x].descestado,
                color: color_calendario,
                startsAt: new Date(moment(data[x].fsalida, "DD/MM/YYYY")),
                endsAt: new Date(moment(data[x].fsalida, "DD/MM/YYYY").add(data[x].unidad - 1, 'days', "DD/MM/YYYY")),
                draggable: true,
                resizable: true,
                allDay: false
              }

            }
            
            // AGARRO TODAS LAS VACACIONES DE LOS EMPLEADOS A CARGO.
            $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados' })
              .success(function (data) {
                for (var x = 0; x < data.length; x++) {
                  // ASIGNO EL COLOR DEL EVENTO DEPENDIENDO DEL ESTADO DE LA SOLICITUD.
                  if (data[x].estado == 'I') { // ESTADO INGRESADO
                    var color_calendario = calendarConfig.colorTypes.warning
                  } if (data[x].estado == 'P') { // ESTADO PREAPROBADO
                    var color_calendario = calendarConfig.colorTypes.info
                  } if (data[x].estado == 'A') { // ESTADO APROBADO
                    var color_calendario = calendarConfig.colorTypes.success
                  } if (data[x].estado == 'R' || data[x].estado == 'X') { // ESTADO RECHAZADO O ANULADO
                    var color_calendario = calendarConfig.colorTypes.important
                  }

                  // INGRESO LAS SOLICITUDES EN EVENTS[X]
                  $scope.events[x] = {
                    title: data[x].nombre + ' - ' + 'Vacaciones' + ' - Fecha desde: ' + data[x].fsalida + ' - Días: ' + data[x].dias + ' - Estado: ' + data[x].descestado,
                    color: color_calendario,
                    startsAt: new Date(moment(data[x].fsalida, "DD/MM/YYYY")),
                    endsAt: new Date(moment(data[x].fsalida, "DD/MM/YYYY").add(data[x].dias - 1, 'days', "DD/MM/YYYY")),
                    draggable: true,
                    resizable: true,
                    allDay: false
                  }

                }
              })
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          })
          .finally(function () {
            $scope.loading = false;
          });

      }

      // CAMBIAMOS EL ESTADO DEL CONTENIDO DEL CALENDARIO EN CADA ACCION, CERRADO O ABIERTO.
      $scope.timespanClicked = function (date, cell) {

        if ($scope.calendarView === 'month') {
          if (($scope.cellIsOpen && moment(date).startOf('day').isSame(moment($scope.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
            $scope.cellIsOpen = false;
          } else {
            $scope.cellIsOpen = true;
            $scope.viewDate = date;
          }
        }

      };

      // UN INTERVALO PARA MOSTRAR UN LOADING AL CAMBIAR EL CALENDARIO DE MES, PARA EVITAR MOSTRAR DATOS INCORRECTOS.
      $scope.load = function () {
        $scope.loading = true
        $timeout($scope.callAtTimeout, 600);
      };
      $scope.callAtTimeout = function () {
        $scope.loading = false;
      }

      // LLAMADA FUNCION PARA CARGAR EVENTOS AL INICIAR PROGRAMA.
      $scope.refresh();

    }

  }

})();

(function () {
  'use strict';


  angular.module('SelfService.pages.supervisor.solicitarpersonal')
    .controller('SolicitarPersonalPageCtrl', SolicitarPersonalPageCtrl);

  /** @ngInject */
  function SolicitarPersonalPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG, $timeout) {


    //TOKEN DE SEGURIDAD PARA EL LOGIN 
    if (!$localStorage.user.token) {
      $location.path('/login');
    }
    
    $scope.rol = $localStorage.user.rol;

    if ($scope.rol == 'ADMIN') {

      // VARIABLES PRINCIPALES
      $scope.emp = $localStorage.user.empresa.nomabre;
      $scope.personal = {};
      $scope.personalSolicitado = {};
      // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
      $scope.itemsByPage = 5;

      // DEFINO EL DIA ACTUAL.
      $scope.sysdate = moment().format("DD/MM/YYYY");

      //SLIDER PARA EDAD
      $scope.slider = {
        minValue: 18,
        maxValue: 75,
        options: {
          floor: 1,
          ceil: 100,
          step: 1,
          hideLimitLabels: true
        }
      }

      // LLAMADAS PARA CARGAR LOS SELECTS
      // FUNCION QUE TRAE TODOS LOS TURNOS POR EL PAIS DEL USUARIO DE LA TABLA "THTURNOSS"
      $scope.getTurnos = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/turnos/pais/' + $localStorage.user.empresa.pais })
          .success(function (data) {
            $scope.turnos = data;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCION QUE TRAE TODOS LOS PUESTOS DE TRABAJO DE LA TABLA "THPUESTOSSS"
      $scope.getPuestos = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/puestos/' })
          .success(function (puestos) {
            $scope.puestos = puestos;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCION QUE TRAE TODAS LAS CAUSAS DE LA TABLA "THCODMODTRSS"
      $scope.getCausas = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/causas/' })
          .success(function (causa) {
            $scope.causa = causa;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCION QUE TRAE TODOS LOS MOTIVOS DE LA TABLA "THRUBMOTRSS"
      $scope.getMotivos = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/motivos/' })
          .success(function (motivo) {
            $scope.motivo = motivo;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCION QUE TRAE TODOS LOS LUGAR DE TRABAJO DE LA TABLA "THCODLUGSS"
      $scope.getLugarTrabajo = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/lugartrabajo/' })
          .success(function (lugarTrabajo) {
            $scope.lugarTrabajo = lugarTrabajo;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCION QUE TRAE TODAS LAS SOLICITUDES DE PERSONAL DE LA TABLA "THSOLPERSS"
      $scope.getSolicitarPersonal = function () {
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/solicitarpersonal' })
          .success(function (data) {
            $scope.personalSolicitado = data;
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      }

      // FUNCIÓN PARA ELIMINAR LA SOLICITUD DE PERSONAL PENDIENTE.
      $scope.onDelete = function (item) {

        $http({ method: 'PUT', url: SELFS_CONFIG.url + '/solicitarpersonal/' + item.id, data: angular.toJson(item) })
          .success(function (data) {
            $scope.getSolicitarPersonal();
            toastr.success('Se ha eliminado la solicitud de personal.');
          })
          .error(function (status) {
            $scope.getSolicitarPersonal();
            toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
          });

      };

      // FUNCION PARA CREAR UNA SOLICITUD DE PERSONAL EN LA TABLA "THSOLPERSS"
      $scope.SolicitarPersonal = function () {
        $http({
          method: 'POST', url: SELFS_CONFIG.url + '/solicitarpersonal',
          data: {
            "fecsol": $scope.sysdate,
            "puesto": $scope.personal.puestos.puesto,
            "empsolicitante": $localStorage.user.emp,
            "edadd": $scope.slider.minValue,
            "edadh": $scope.slider.maxValue,
            "sexo": $scope.personal.genero,
            "codlug": $scope.personal.lugarTrabajo.id,
            "turno": $scope.personal.turnoSel.turno,
            "usuario": $localStorage.user.legajo,
            "estado": "PE",
            "tareas": $scope.personal.observaciones,
            "causa": $scope.personal.causa.id,
            "motivo": $scope.personal.motivo.id
          }
        })
          .success(function (response) {
            toastr.success('', 'Se ha enviado su solicitud de personal.');
            $scope.getSolicitarPersonal();

            // LUEGO DEL POST BLANQUEO LOS VARIABLES DEL FRONT 
            $scope.slider.minValue = 18;
            $scope.slider.maxValue = 75;
            $scope.personal.genero = "";
            $scope.personal.lugarTrabajo = "";
            $scope.personal.turnoSel = "";
            $scope.personal.observaciones = "";
            $scope.personal.causa = "";
            $scope.personal.motivo = "";
            $scope.personal.puestos = "";
          })
          .error(function (status) {
            toastr.error('Código de error: ' + status, 'Falló al solicitar personal.');
          });
      }

      // LLAMADA DE LAS FUNCIONES AL INICIAR LA PAGINA.
      $scope.getSolicitarPersonal();
      $scope.getTurnos();
      $scope.getPuestos();
      $scope.getLugarTrabajo();
      $scope.getCausas();
      $scope.getMotivos();

      // (REFRESH SLIDER) FUERZA EL SLIDER A REINICIARSE, ASI SE MODIFICA EL TAMAÑO AL INICIARSE LA PANTALLA.
      $scope.refreshSlider = function () {
        $timeout(function () {
          $scope.$broadcast('rzSliderForceRender');
        });
      }
      $scope.refreshSlider();
    }
  }
}

)();
(function () {
  'use strict';

  angular.module('SelfService.pages.vacaciones')
      .controller('recibosVacacionesModal', recibosVacacionesModal);

  /** @ngInject */
  function recibosVacacionesModal($scope, $location, $localStorage, $http, toastr, toastrConfig, SELFS_CONFIG, recibosDetalle) {
      $scope.recibosCollection = [];
   
   if (!$localStorage.user.token) {
     $location.path('/login');
   }
   
   $scope.recibosCollection = recibosDetalle;

    $scope.getRecibo = function (idArchivo){
      $http({method: 'GET', 
            url: SELFS_CONFIG.url + '/vacaciones/recibos/' + idArchivo,
            responseType: 'arraybuffer'
            }) 
        .success( function(data, status, headers, config) {
            var contentDispositionHeader = headers('Content-Disposition');
            var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
            var filename = result.replace(/"/g, '');     

            var blob = new Blob([data], {type: "application/pdf"});
            
                //HDY: AGREGO CODIGO PARA LINEA DE CÓDIGO PARA QUE FUNCIONE EN EXPLORER
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob,filename);
                }
                else {
                            var objectUrl = URL.createObjectURL(blob);
                            var a = document.createElement('a');
                                a.href = objectUrl;
                                a.download = filename;
                                a.target = '_blank';
                                //HDY: AGREGO LINEA DE CÓDIGO PARA QUE FUNCIONE EN FIREFOX
                                if(document.body != null)
                                { 
                                    document.body.appendChild(a); 
                                }
                                a.click(); 
                }

            })
        .error( function(status) {
            toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
        });
    }
    
}
})();

(function () {
  'use strict';

  angular.module('SelfService.pages.vacaciones')
      .controller('vacacionesModalCtrl', vacacionesModalCtrl);

  /** @ngInject */
  function vacacionesModalCtrl($scope, $location, $localStorage, $http, toastr, toastrConfig, vacacionesDetalle) {
      $scope.vacacionesCollection = [];

      if (!$localStorage.user.token) {
        $location.path('/login');
      }
      
      $scope.vacacionesCollection = vacacionesDetalle;
   
}
})();

(function () {
  'use strict';


  angular.module('SelfService.pages.vacaciones')
    .directive('enter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            event.preventDefault();
            var fields = $(this).parents('form:eq(0),body').find('input, textarea, select');
            var index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length)
              fields.eq(index + 1).focus();
          }
        });
      };
    });



  angular.module('SelfService.pages.vacaciones')
    .controller('SolicitarVacacionesPageCtrl', SolicitarVacacionesPageCtrl);

  /** @ngInject */
  function SolicitarVacacionesPageCtrl($scope, $uibModal, $http, $location, $localStorage, toastr, toastrConfig, SELFS_CONFIG) {

    //TOKEN DE SEGURIDAD PARA EL LOGIN 
    if (!$localStorage.user.token) {
      $location.path('/login');
    }

    // VARIABLES PRINCIPALES
    $scope.vacaciones = {};
    $scope.vacacionesDetalle = [];
    $scope.min = moment();
    // VARIABLE QUE DETERMINA LOS ITEMS POR PAGINA DE LA TABLA.
    $scope.itemsByPage = 5;

    $scope.openModalVacaciones = function (item) {
      $scope.vacacionesDetalle = [];

      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/detalle/' + item.periodo })
        .success(function (data) {
          $scope.vacacionesDetalle = data;

          var vacacionesModal = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/vacaciones/modals/vacacionesModal.html',
            size: 'lg',
            controller: 'vacacionesModalCtrl',
            resolve: {
              vacacionesDetalle: function () {
                return $scope.vacacionesDetalle;
              }
            }
          });
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    };

    $scope.openModalReciboVacaciones = function () {
      $scope.recibosDetalle = {};

      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/recibos' })
        .success(function (data) {
          $scope.recibosDetalle = data;

          if ($scope.recibosDetalle != null && $scope.recibosDetalle != "") {

            var reciboVacacionesModal = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/vacaciones/modals/recibosVacacionesModal.html',
              size: 'lg',
              controller: 'recibosVacacionesModal',
              resolve: {
                recibosDetalle: function () {
                  return $scope.recibosDetalle;
                }
              }
            })
          } else {
            toastr.error('No hay notificaciones para mostrar.');
          }

        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });
    };


    // FUNCION PARA ENVIAR EL PEDIDO DE VACACIONES.
    $scope.enviarSolicitud = function () {

      var fecha = $scope.vacaciones.fsalida;
      var dias = $scope.vacaciones.cantdias;

      // GET PARA OBTENER TODAS LAS VACACIONES APROBADAS DEL USUARIO LOGUEADO
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/validacion_licencia/solapamiento_vacaciones' })
        .success(function (vacaciones) {
          var keepGoing = true;
          var data_length = vacaciones.length;
          // VALIDO SI EXISTE SOLAPAMIENTO DE UNA NOVEDAD DE LINCENCIA INGRESADA CONTRA VACACIONES APROBADAS
          for (var i = 0; i < dias; i++) {
            // EN ESTE CASO MOMENT LA USAMOS PARA CALCULAR LAS FECHAS SIGUIENTES.
            var nfs = moment(fecha, "DD/MM/YYYY").add(i, 'days').format("DD/MM/YYYY");
            for (var x = 0; x < data_length; x++) {
              for (var z = 0; z < vacaciones[x].dias; z++) {
                if (keepGoing) {
                  var nfr = moment(vacaciones[x].fsalida, "DD/MM/YYYY").add(z, 'days').format("DD/MM/YYYY");
                  if (nfs == nfr) {
                    keepGoing = false;
                    toastr.error('La fecha seleccionada está ocupada por días de vacaciones.');
                  }
                }

              }

            }

          }

          // KEEPGOING ES UNA BANDERA QUE VALIDA EL SOLAPAMIENTO, EN CASO DE EXISTIR UNA NOVEDAD INGRESADA EN ESA FECHA.
          if (keepGoing == true) {
            $http({
              method: 'POST', url: SELFS_CONFIG.url + '/vacaciones/pedidos',
              data: {
                "emp": $localStorage.user.emp,
                "legajo": $localStorage.user.legajo,
                "periodo": $scope.vacaciones.periodo,
                "dias": $scope.vacaciones.cantdias,
                "fsalida": fecha,
                "estado": "I",
                "comentario": $scope.vacaciones.observaciones
              }
            })
              .success(function (response) {
                $scope.refresh();
                toastr.success('', 'Se ha enviado su solicitud de vacaciones.');
              })
              .error(function (status) {
                toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
              });
            $scope.periodo.periodo = "";
            $scope.vacaciones.fsalida = "";
            $scope.vacaciones.fsalida1 = "";
            $scope.vacaciones.cantdias = "";
            $scope.vacaciones.periodo = "";
            $scope.vacaciones.observaciones = "";
          }
        })

        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Falló la actualización de datos.');
        });
    }

    // FUNCIÓN PARA ELIMINAR LAS VACACIONES INGRESADAS.
    $scope.onDelete = function (item) {

      // METODO PARA OBTENER LOS PEDIDOS INGRESADOS POR ID
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados/' + item.id })
        .success(function (data) {
          // PREGUNTO SI EL ESTADO ES INGRESADO PARA HACER EL DELETE DE LAS VACACIONES
          if (data.estado == "I") {
            $http({
              method: 'PUT', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados/eliminar/' + item.id,
              data: angular.toJson(item)
            })
              .success(function (response) {
                $scope.refresh()
                toastr.success('', 'Las vacaciones solicitadas se eliminaron correctamente.');
              })
              .error(function (response, status, headers, config) {
                $scope.refresh()
                toastr.error('', 'Error las vacaciones a eliminar ya han sido modificadas.');
              });
            // SI EL ESTADO FUE MODIFICADO POR LA PERSONA A CARGO VA A DEVOLVER UN MENSAJE DE ERROR
          } else if (data.estado == "P" || data.estado == "A") {
            $scope.refresh()
            toastr.error('', 'Error las vacaciones a eliminar ya se encuentran aprobadas.');
          } else if (data.estado == "R") {
            $scope.refresh()
            toastr.error('', 'Error las vacaciones a eliminar ya se encuentran rechazadas.');
          }
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    };

    //Datepickers
    $scope.onChangeDateFvac = function (newValue) {

      if (typeof newValue === 'undefined' || !newValue) {
        $scope.vacaciones.fsalida = null;
      } else {
        $scope.newFvac = newValue;
        var castDatePicker = moment($scope.newFvac).format('DD/MM/YYYY');
        $scope.vacaciones.fsalida = castDatePicker;
      }
    };

    //SELECTS 
    //TODO: REFACTORING
    $scope.tablaVacaciones = [];

    //LLAMADA PARA CARGAR LOS SELECTS
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones' })
      .success(function (datosVacaciones) {
        $scope.tablaVacaciones = datosVacaciones;
      })

    $scope.periodoSeleccionado = function (periodo) {
      vacacionesUrl.setParametro(periodo);
    }

    //LLAMADA PARA CARGAR LAS VACACIONES SOLICITADAS
    $scope.vacacionesSolicitadas = [];
    $scope.getVacacionesSolicitadas = function () {
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos' })
        .success(function (data) {
          $scope.vacacionesSolicitadas = data;
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    }

    $scope.pedirVacaciones = [];
    $scope.getpedirVacaciones = function () {
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pendiente' })
        .success(function (data) {
          $scope.pedirVacaciones = data;
        })
        .error(function (status) {
          toastr.error('Código de error: ' + status, 'Error en la petición de datos.');
        });

    }

    $scope.periodo = [];

    $scope.maxDias = 50;

    $scope.onChangeMaxDias = function (newValue) {
      $scope.maxDias = newValue.diasPendientes;
      $scope.vacaciones.periodo = newValue.periodo;
    }



    $scope.getpedirVacaciones();
    $scope.getVacacionesSolicitadas();


    $scope.refresh = function () {
      $scope.getVacacionesSolicitadas();
    }


  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('SelfService.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('SelfService.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function () {
    'use strict';

    angular.module('SelfService.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService) {

        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function () {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });


        /***** JS DEL ASISTENTE VIRUTAL ******/
        //DialofFlow > yacireta_bot - tecnologia@opensolutions.com.ar - open2017  
        var accessToken = "d6a89e7f6c854f4eb1edfb79d9a709a6";
        var baseUrl = "https://api.dialogflow.com/v1/";


        var needContact = [
            'Saludo.Saludo-custom.Saludo-Productos-custom.Saludo-Productos-rhgob-yes.Saludo-Productos-rhgob-yes-custom',
            'Saludo.Saludo-custom.Saludo-Productos-custom.Saludo-Productos-ERP2-yes.Saludo-Productos-ERP2-yes-yes',
            'Saludo.Saludo-custom.Saludo-Productos-custom.Saludo-Productos-Work-yes.Saludo-Productos-Work-yes-custom',
            'Saludo.Saludo-custom.Saludo-Productos-custom-2.Saludo-Productos-SARHA-yes.Saludo-Productos-SARHA-yes-custom',
            'Saludo.Saludo-custom.Saludo-SARHA-yes.Saludo-SARHA-yes-custom',
            'Saludo.Saludo-custom.Saludo-Llamada-custom',
            'Saludo.Saludo-custom.Saludo-servicio-yes.Saludo-servicio-yes-custom'
        ];

        $(function () {
            queryBot('hola');

            function urlify(text) {
                var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

                return text.replace(urlRegex, function (url) {
                    return '<a target="_blank" href="' + url + '">' + 'click acá' + '</a>';
                })
            }


            // MANDO LOS MENSAJES GENERADOS AL CHATBOX.
            function queryBot(text) {
                $.ajax({
                    type: "POST",
                    url: baseUrl + "query?v=20150910",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    headers: { "Authorization": "Bearer " + accessToken },
                    data: JSON.stringify({ query: text, lang: "en", sessionId: "OpenSolutions" }),
                    success: function (data) {
                        if (data.result.fulfillment.speech) {
                            var infoContacto = data.result.resolvedQuery

                            for (var i = 0; i < needContact.length; i++) {
                                if (data.result.action == needContact[i]) {
                                    $.ajax({
                                        type: 'POST',
                                        data: { contacto: infoContacto },
                                        url: 'php/action/sendemail.php',
                                        dataType: 'json',
                                        async: false,
                                        success: function (result) {
                                            console.log('success.' + result);
                                        },
                                        error: function (result) {
                                            console.log('error. ' + result);
                                        }
                                    });
                                }
                            }

                            generate_message(urlify(data.result.fulfillment.speech), 'user', 'bot');
                        }
                    },
                    error: function () {
                        generate_message('No hay ningún agente disponible para atender su consulta en este momento. Intente más tarde. ', 'user', 'bot');
                    }
                });
            }

            var msgId = 0;

            // GENERO EL MENSAJE.
            function generate_message(msg, type, avatar){
                msgId++;
                var str="";
        
                str += "<div id='cm-msg-" + msgId + "' class=\"chat-msg "+type+"\">";
                str += "<div class=\"cm-msg-text\">";
                str +=      msg;
                str += "<\/div>";
                str += "<\/div>";
            
                $(".chat-logs").append(str);
                $("#cm-msg-" + msgId).hide().fadeIn(300);
        
                if(type == 'self'){
                    $("#chat-input").val(''); 
                }
        
                $(".chat-logs").stop().animate({ scrollTop: $(".chat-logs")[0].scrollHeight}, 1000);    
            } 

            $(document).delegate(".chat-btn", "click", function () {
                var name = $(this).html();
                $("#chat-input").attr("disabled", false);
                generate_message(name, 'self', 'anon');
            })

            // CADA VEZ QUE SE ENVIE UN MENSAJE VA A LLAMAR A ESTA FUNCION.
            $("#chat-submit").click(function (e) {
                e.preventDefault();
                var msg = $("#chat-input").val();

                if (msg.trim() == '') {
                    return false;
                }
                generate_message(msg, 'self', 'anon');
                queryBot(msg);

            })
            
            //Seleccion de opciones del menu
            $(function () {
                $("#cusSelectbox").change(function () {
                    $("#chat-input").val($(this).val());
                    $("#chat-submit").click();
                })
            });

            //Evento del boton del chat
            $("#chat-circle").on('click', function () {
                $("#chat-circle").toggleClass('opened');
                $(".chat-box").toggle("slow");
                $(".list-box").fadeToggle('fast');
                $(".list-box").fadeToggle('slow');
            });

            // ABRO EL CHAT
            $('#chat-circle').tooltip();

            // OCULTO EL CHATBOX
            $(".chat-box-toggle").click(function () {
                $("#chat-circle").toggleClass('opened');
                $(".chat-box").toggle("slow");
            })

            // OCULTO LA LISTA DE OPCIONES.
            $(".list-box-toggle").click(function () {
                $(".list-box").fadeToggle('fast');
            })

            //Evento del boton de opciones
            $("#chat-option").click(function (e) {
                e.preventDefault();
                $(".list-box").fadeToggle('fast');
            });
        })
    }
})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('SelfService.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length - 1,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('SelfService.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('SelfService.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('SelfService.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();

(function () {
  'use strict';
  angular.module('SelfService.theme.components')
    .directive('pageTop', pageTop);

  function pageTop($http, SELFS_CONFIG, $localStorage) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'selfsController',
      /** Desde aca*/
      link: function (scope, element, attrs, $scope) {
        // Url de Api REST
        $scope.rol = $localStorage.user.rol;
        if ($scope.rol == 'ADMIN') {
          getNews(scope, $http, SELFS_CONFIG);
        }
      }
      /** Hasta aca */
    };



  }

  /** Desde Aca */
  // Obtiene notificaciones
  function getNews($scope, $http, SELFS_CONFIG) {
    // Obtener datos de notificaciones  

    // AGARRO LAS NOVEDADES INGRESADAS PARA MOSTRAR LA CANTIDAD EN LA CAMPANITA.
    $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados' })
      .success(function (response, status, headers, config) {
        // Información de Notificaciones
        $scope.newsNotiLic = response;
      })
      .error(function (data) {
        $scope.notify("La sesión ha expirado", "error");
      });

      // AGARRO LAS VACACIONES INGRESADAS PARA SUMARLE LA CANTIDAD A LA CAMPANITA.
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados' })
      .success(function (response, status, headers, config) {
        // Información de Notificaciones
        $scope.newsNotiVac = response;
      })
      .error(function (data) {
        $scope.notify("La sesión ha expirado", "error");
      });

    /******************/
    $scope.limpiar = function () {

      $scope.newsNotiLic = [];
      $scope.newsNotiVac = [];


      // AGARRO LAS NOVEDADES INGRESADAS PARA MOSTRAR LA LISTA EN LA NOTIFICACION.
      $http({ method: 'GET', url: SELFS_CONFIG.url + '/novedades-liquidacion/pedidos/subordinados/ingresados' })
        .success(function (response) {
          $scope.newsLic = response;
        })
        .error(function (data) {
          $scope.notify("La sesión ha expirado", "error");
        });

        // AGARRO LAS VACACIONES INGRESADAS PARA MOSTRAR LA LISTA EN LA NOTIFICACION.
        $http({ method: 'GET', url: SELFS_CONFIG.url + '/vacaciones/pedidos/subordinados/ingresados' })
        .success(function (response) {
          $scope.newsVac = response;
        })
        .error(function (data) {
          $scope.notify("La sesión ha expirado", "error");
        });
    };
    /******************/

  }
  /** Hasta aca */

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('SelfService.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
(function () {
  'use strict';

  angular.module('SelfService.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'jpg';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('SelfService.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('SelfService.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('SelfService.pages.supervisor.equipotrabajo').controller('legajoModalCtrl', legajoModalCtrl);
    function legajoModalCtrl($scope, $http, toastr, toastrConfig, parametroUrle) {

        $scope.legajoModalData = [];

        // close y dismiss de modal
        $scope.closeModal = function(){
            $scope.$close();
        };

        $scope.dismissModal = function(){
            $scope.$dismiss();
        };
        

        var l_urle = parametroUrle.getParametro();
        $http({ method: 'GET', url: l_urle})        
            .success(function (data) {
                $scope.legajoModalData = data;  
            })
            .error(function (data, status, headers, config) {
                toastr.error('Código de error: ' + status , 'Error en la petición de datos.');
            });

    }
 
})();   
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module("SelfService").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/404/404.html","<div class=\"page-not-found-modal\"><h1>404 Error</h1><p>Sorry, that page doesn\'t exist. <a href=\"/\">Go to Home Page.</a></p></div>");
$templateCache.put("app/pages/certificados/certificados.html","<div class=\"widgets\"><form name=\"certificadoForm\" ng-model=\"certificadoForm\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Adjuntar documentos\" ba-panel-class=\"panel light-text\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"tiposCertificado\">Tipo de documento</label><select class=\"form-control\" ng-model=\"certificado.tipoCertificado\" ng-options=\"obj.codnov as obj.desccodnov for obj in tiposCertificado\" ng-change=\"getFechaCertificado(certificado)\" ng-required=\"true\"><option value=\"\">-- Elegir tipo de documento --</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputLastName\">Descripción del certificado a subir</label> <input type=\"text\" ng-required=\"true\" ng-model=\"certificado.descripcion\" class=\"form-control\" placeholder=\"\"></div></div><div ng-if=\"tiposCertificado[indice].rcertif == \'S\'\" class=\"col-sm-4\"><div class=\"form-group\"><label for=\"FechaCerfif\">Seleccionar novedad</label><select class=\"form-control\" ng-model=\"certificado.FechaCerfif\" ng-options=\"\'Fecha de salida: \' + obj.fsalida + \' | Cantidad de días: \' + obj.unidad for obj in fechaCerfif\" ng-required=\"true\" ng-value=\"obj.id\"><option value=\"\">-- Elegir novedad --</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group row\"><label for=\"aplicacion\">Adjuntar documentación</label> <i class=\"fa fa-trash-o settings-list-icon hidden-xs\" ng-click=\"resetFileUploader()\" ng-if=\"certificado.miArchivo\"></i> <input id=\"upcontrol\" type=\"file\" accept=\".pdf,.doc,.docx,.xls,.xlsx,image/*\" ng-required=\"true\" ng-model=\"certificado.miArchivo\" base-sixty-four-input=\"\" custom-on-change=\"uploadFile\"><div style=\"color: red; margin-bottom: 0px;\" class=\"alert animated bounceIn\" ng-show=\"fileInvalid\">El archivo no es válido (Admite JPG, PNG, DOC, XLS y PDF hasta 5 MB)</div><div style=\"color: red; margin-top: 0px; padding-top: 0px;\" class=\"alert animated bounceIn\" ng-show=\"fileInvalidString\">El nombre de archivo especificado es demasiado largo</div></div></div></div><br><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"guardarCertificado()\">Subir certificado</button></div></div></div><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Documentos subidos\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><table ng-table=\"certificadosCargados\" st-table=\"displayedCollection\" st-safe-src=\"certificadosCollection\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th></th><th st-sort=\"nombreOriginal\" class=\"align-center\">Documentos</th><th st-sort=\"tipoDescripcion\" class=\"align-center\">Tipo</th><th st-sort=\"descripcion\" class=\"align-center\">Descripción</th><th st-sort=\"fechaAlta\" class=\"align-center\">Fecha de ingreso</th><th st-sort=\"renglon\" st-sort-default=\"reverse\" class=\"align-center\">Descargar</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td></td><td class=\"align-center\">{{item.nombreOriginal}}</td><td class=\"align-center\">{{item.tipoDescripcion}}</td><td class=\"align-center\">{{item.descripcion}}</td><td class=\"align-center\">{{item.fechaAlta}}</td><td class=\"align-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getCertificado(item.renglon);\"><i class=\"ion-archive\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></form></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"large-panel with-scroll feed-panel\"><blur-feed></blur-feed></div></div></div>");
$templateCache.put("app/pages/datos/datos.html","<form ng-submit=\"actualizarLegajo()\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Domicilio\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><label for=\"calle\">Calles</label> <input type=\"text\" class=\"form-control\" ng-model=\"datos.domcalle\" maxlength=\"30\"></div><div class=\"form-group\"><label for=\"numero\">Número</label> <input type=\"number\" min=\"0\" max=\"99999\" class=\"form-control\" ng-model=\"datos.domnro\"></div><div class=\"form-group\"><label for=\"piso\">Piso</label> <input type=\"text\" class=\"form-control\" ng-model=\"datos.dompiso\" maxlength=\"3\"></div><div class=\"form-group\"><label for=\"departamento\">Departamento</label> <input type=\"text\" class=\"form-control\" ng-model=\"datos.domdepto\" maxlength=\"5\"></div><div class=\"form-group\"><label for=\"pais\">País</label><select ng-model=\"datos.pais\" class=\"form-control\" ng-options=\"obj.pais as obj.descpais for obj in paisesBase\" ng-required=\"true\" id=\"pais\"></select></div><div class=\"form-group\"><label for=\"provincia\">Provincia</label><select ng-model=\"datos.pcia\" ng-options=\"x.pcia as x.descpcia for x in pciaBase | filter:filterPorPais(datos.pais)\" class=\"form-control\" ng-required=\"true\" id=\"pcia\"></select></div><div class=\"form-group\"><label for=\"ciudad\">Código postal y localidad</label><select ng-model=\"datos.codp\" ng-options=\"x.codp as x.codp + \' - \' + x.ciudad for x in ciudadesBase | filter: {pais:datos.pais} | filter: {pcia:datos.pcia}\" class=\"form-control\" ng-required=\"true\" id=\"ciudad\"></select></div><div class=\"form-group\"><label for=\"barrio\">Barrio</label> <input type=\"text\" class=\"form-control\" ng-model=\"datos.barrio\" maxlength=\"40\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Datos Personales\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><label for=\"telefono\">Teléfono</label> <input type=\"text\" class=\"form-control\" ng-model=\"datos.telef\" maxlength=\"25\"></div><div class=\"form-group\"><label for=\"email\">Email</label> <input type=\"email\" class=\"form-control\" ng-model=\"datos.email\" maxlength=\"50\"></div><div class=\"form-group\"><label for=\"nacionalidad\">Nacionalidad</label><select ng-model=\"datos.codnac\" class=\"form-control\" ng-options=\"obj.codnac as obj.desccodnac for obj in nacionalidadesBase\" ng-required=\"true\" id=\"codnac\"></select></div><div class=\"form-group\"><label for=\"fechaNacimiento\">Fecha de nacimiento</label><p class=\"input-group\"><input class=\"form-control\" ng-model=\"datePickerFnacim\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"LegajoCtrlFnacim\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" autoclose=\"true\" keyboard=\"true\" change=\"onChangeDateFnacim(newValue)\" ng-required=\"true\"></p></div><div class=\"form-group\"><label for=\"estadoCivil\">Estado Civil</label><select ng-model=\"datos.ecivil\" class=\"form-control\" ng-options=\"obj.codigo as obj.valor for obj in estadosCivilesBase\" ng-required=\"true\" id=\"ecivil\"></select></div><div class=\"form-group\"><label for=\"fechaCasamiento\">Fecha de casamiento</label><p class=\"input-group\"><input class=\"form-control\" ng-model=\"datePickerFcasam\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"LegajoCtrlFcasam\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" autoclose=\"true\" keyboard=\"true\" change=\"onChangeDateFcasam(newValue)\"></p></div><br><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\">Guardar cambios</button></div></div></div></div></form>");
$templateCache.put("app/pages/evolucion/evolucion.html","<div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"Tareas\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"tareas\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"desccodnue\" class=\"text-center\">Puesto</th><th st-sort=\"fdesde\" class=\"text-center\">Fecha Desde</th><th st-sort=\"fhasta\" class=\"text-center\">Fecha Hasta</th><th st-sort=\"antiguedad\" class=\"text-center\">Meses en la Posición</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"text-center\">{{item.desccodnue}}</td><td class=\"text-center\">{{item.fdesde}}</td><td class=\"text-center\">{{item.fhasta}}</td><td class=\"text-center\">{{item.antiguedad}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div><div ba-panel=\"\" ba-panel-title=\"Funciones\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"text-center\">Puesto</th><th class=\"text-center\">Fecha Desde</th><th class=\"text-center\">Fecha Hasta</th><th class=\"text-center\">Meses en la Posición</th></tr></thead><tbody><tr ng-repeat=\"item in funciones\" class=\"no-top-border\"><td class=\"text-center\">{{item.desccodnue}}</td><td class=\"text-center\">{{item.fdesde}}</td><td class=\"text-center\">{{item.fhasta}}</td><td class=\"text-center\">{{item.antiguedad}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/familiares/familiares.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Familiares ingresados\" ba-panel-class=\"medium-panel with-scroll table-panel\"><div class=\"horizontal-scroll\"><table st-table=\"displayedCollection\" st-safe-src=\"familiaresTableData\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th></th><th st-sort=\"nombre\" class=\"align-left\">Nombre</th><th st-sort=\"fnacim\" class=\"align-left\">Fecha de nacimiento</th><th st-sort=\"desccodfam\" class=\"align-left\">Tipo de familiar</th><th st-sort=\"descsexo\" class=\"align-left\">Sexo</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td></td><td ng-class=\"align-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" ng-click=\"openModal(item.codfam,item.numfam)\">{{item.nombre}}</button></td><td class=\"align-left\">{{item.fnacim}}</td><td class=\"align-left\">{{item.desccodfam}}</td><td class=\"align-left\">{{item.descsexo}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/ganancias/ganancias.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Descarga de formulario detallado\" ba-panel-class=\"large-panel with-scroll table-panel\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"horizontal-scroll\"><table st-table=\"displayedCollection\" st-safe-src=\"detallado649Collection\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th></th><th st-sort=\"fechaAlta\" class=\"align-center\">Fecha de alta</th><th st-sort=\"nombre\" class=\"align-center\">Nombre del archivo</th><th st-sort=\"legajo\" class=\"align-center\">Legajo</th><th st-sort=\"renglon\" st-sort-default=\"reverse\" class=\"align-center\">Descargar</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td></td><td class=\"align-center\">{{item.fechaAlta}}</td><td class=\"align-center\">{{item.nombre}}</td><td class=\"align-center\">{{item.legajo}}</td><td class=\"align-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getDetallado(item.renglon);\"><i class=\"ion-archive\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div><div ba-panel=\"\" ba-panel-title=\"Descarga de formulario\" ba-panel-class=\"large-panel with-scroll table-panel\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"horizontal-scroll\"><table st-table=\"displayedCollection\" st-safe-src=\"formularios649Collection\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th></th><th st-sort=\"fechaAlta\" class=\"align-center\">Fecha de alta</th><th st-sort=\"nombre\" class=\"align-center\">Nombre del archivo</th><th st-sort=\"legajo\" class=\"align-center\">Legajo</th><th st-sort=\"renglon\" st-sort-default=\"reverse\" class=\"align-center\">Descargar</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td></td><td class=\"align-center\">{{item.fechaAlta}}</td><td class=\"align-center\">{{item.nombre}}</td><td class=\"align-center\">{{item.legajo}}</td><td class=\"align-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getFormulario(item.renglon);\"><i class=\"ion-archive\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/login/login.html","<main class=\"auth-main\"><div class=\"hidden-xs background_branding_container\" role=\"banner\"><style>\n      body {\n        background: url(\'../assets/img/fondo_login_ss.png\') no-repeat fixed !important;\n        background-size: 100% 100% !important;\n      }\n\n      .mobile {\n\n        display: none;\n\n      }\n\n      @media (max-width: 899px) {\n\n        .mobile {\n          display: inline;\n\n        }\n\n      }\n    </style></div><div class=\"auth-block\" role=\"main\"><h1><img src=\"/assets/img/condor_link.png\" class=\"link-logo-ml\"></h1><br><form class=\"form-horizontal\" ng-submit=\"login()\"><div class=\"form-group\"><p class=\"login-input\" for=\"usuario\">Usuario</p><div><input type=\"text\" class=\"form-control login-background\" id=\"usuario\" autofocus=\"\" ng-model=\"user.usuario\"></div></div><div class=\"form-group\"><p class=\"login-input\" for=\"password\">Contraseña</p><div><input type=\"password\" class=\"form-control login-background\" id=\"password\" ng-model=\"user.password\"></div><span class=\"center clickable-span\" ng-click=\"olvidoDeContrasenia()\"><br>Olvidé mi contraseña</span></div><br><div class=\"align-center\"><button type=\"submit\" class=\"btn login-background\">Ingresar</button><br><br></div></form><div class=\"align-center\"><div class=\"mobile\"><br><a style=\"color: black;\" id=\"a\">Descargar la aplicación</a></div></div></div></main>");
$templateCache.put("app/pages/olvido/olvido.html","<style>\n  body {\n    /* SUBIR IMAGEN A SERVIDOR DE OPEN */\n    background: url(\'http://ss.opensolutions.com.ar/assets/img/fondo_login_ss.png\') no-repeat fixed !important;\n    background-size: 100% 100% !important;\n  }\n</style><main class=\"auth-main\"><div class=\"auth-block\"><h1><img src=\"/assets/img/condor_link.png\" class=\"link-logo-login\"><br><span class=\"forgot-pass-header\">Recuperar contraseña</span></h1><br><form class=\"form-horizontal\" name=\"olvidoForm\" ng-submit=\"submitForm(olvidoForm.$valid, parametros)\" ng-show=\"!emailEnviado()\" novalidate=\"\"><div class=\"form-group\"><p class=\"login-input\" for=\"email\">Email</p><input type=\"email\" class=\"form-control login-background\" id=\"email\" name=\"inputEmail\" ng-model=\"parametros.inputEmail\" maxlength=\"50\" required=\"\"><div class=\"required-field\" ng-show=\"olvidoForm.$submitted || olvidoForm.inputEmail.$touched\"><span class=\"required-field\" ng-show=\"olvidoForm.inputEmail.$error.email || olvidoForm.inputEmail.$error.required\">Ingrese un email válido</span></div><span class=\"center clickable-span\" ng-click=\"volver()\"><br>Volver al inicio de sesión</span></div><div class=\"form-group\"><div class=\"align-center\"><button type=\"submit\" class=\"btn login-background\">Confirmar</button></div></div></form><div ng-show=\"emailEnviado()\"><p>Se ha enviado un email con la información necesaria para el blanqueo de su contraseña.</p></div></div></main>");
$templateCache.put("app/pages/perfil/perfil.html","<div class=\"widgets\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"Cambiar contraseña\"><form name=\"perfilForm\" ng-controller=\"PerfilPageCtrl\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\" ng-class=\"{ \'has-error\': perfilForm.inputPassword.$invalid }\"><label for=\"inputPassword\">Contraseña nueva</label> <input type=\"password\" ng-model=\"inputPassword\" class=\"form-control\" name=\"inputPassword\" complex-pass=\"\"> <span style=\"color: red;\" class=\"help-block error-block basic-block\">La contraseña debe tener al menos 8 caracteres</span></div></div><div class=\"col-sm-6\"><div class=\"form-group\" ng-class=\"{ \'has-error\': perfilForm.inputConfirmPassword.$invalid }\"><label for=\"inputConfirmPassword\">Confirmar contraseña</label> <input type=\"password\" class=\"form-control\" ng-model=\"inputConfirmPassword\" name=\"inputConfirmPassword\" placeholder=\"\" check-pass=\"{{perfilForm.inputPassword.$viewValue}}\"><div class=\"form-group\"><span style=\"color: red;\" class=\"help-block error-block basic-block\">Las contraseñas no coinciden</span></div></div></div></div><br><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"cambiarPassword()\" class=\"btn btn-danger\">Actualizar</button></div></form></div></div>");
$templateCache.put("app/pages/recibos/recibos.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Descarga de recibos\" ba-panel-class=\"large-panel table-panel\"><div ng-show=\"estadosRecibosMostrar == true\"><h5>Estado de los recibos</h5><div class=\"progress\"><div ng-style=\"pendientesCSS\" class=\"progress-bar progress-bar\" style=\"background-color: #dddddd; color: #6d6d6d;\">{{pendientesString}}% Pendientes</div><div ng-style=\"firmadosCSS\" class=\"progress-bar progress-bar-info\">{{firmadosString}}% Firmados</div><div ng-style=\"disconformeCSS\" class=\"progress-bar progress-bar-danger\">{{disconformeString}}% No conforme</div></div></div><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{toggleText}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a href=\"\" ng-click=\"filtroEstado = {edigital: \'P\'}; toggle(newValue=\'P\')\">Pendientes</a></li><li><a href=\"\" ng-click=\"filtroEstado = {edigital: \'F\'}; toggle(newValue=\'F\')\">Firmados</a></li><li><a href=\"\" ng-click=\"filtroEstado = {edigital: \'D\'}; toggle(newValue=\'D\')\">Firmados no conforme</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\" ng-click=\"filtroEstado = {}; toggle(newValue=\'T\')\">Todos los recibos</a></li></ul></div><br><br><div class=\"row\"><div class=\"col-sm-12\"><div class=\"horizontal-scroll\"><table st-table=\"displayedCollection\" st-safe-src=\"recibosCollection\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th></th><th st-sort=\"liquidacion\" class=\"align-center\">Liquidación</th><th st-sort=\"legajo\" class=\"align-center\">Legajo</th><th st-sort=\"fechaPago\" st-sort-default=\"true\" class=\"align-center\">Fecha de pago</th><th st-sort=\"descedigital\" class=\"align-center\">Estado</th><th st-sort=\"numliq\" st-sort-default=\"reverse\" class=\"align-center\">Acción</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection | filter:(filtroEstado || undefined)\" class=\"no-top-border\"><td></td><td class=\"align-center\"><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"getRecibo(item.renglon)\">{{item.liquidacion}}</button></td><td class=\"align-center\">{{item.legajo}}</td><td class=\"align-center\">{{item.fechaPago}}</td><td class=\"align-center\">{{item.descedigital}}</td><td class=\"align-center\"><button type=\"button\" ng-show=\"item.edigital==\'P\' || item.edigital==\'D\'\" class=\"btn btn-info btn-xs\" data-toggle=\"modal\" ng-click=\"openModalFirma(item)\"><i class=\"ion-edit\"></i> Firmar</button></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/reset/reset.html","<style>\n  body {\n    /* SUBIR IMAGEN A SERVIDOR DE OPEN */\n    background: url(\'http://ss.opensolutions.com.ar/assets/img/fondo_login_ss.png\') no-repeat fixed !important;\n    background-size: 100% 100% !important;\n  }\n</style><main class=\"auth-main\"><div class=\"auth-block\"><h1><svg class=\"cw-logo-ml\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><polygon class=\"cls-3\" points=\"24.77 28.67 28.94 41.88 30.72 35.16 32.93 28.67 42.2 28.67 33.51 52.54 25.39 52.54 22.07 43.56 18.81 52.54 10.6 52.54 1.95 28.67 11.17 28.67 13.43 35.2 15.26 41.88 19.43 28.67 24.77 28.67\"></polygon><path class=\"cls-3\" d=\"M70,40.58C70,49.23,63.09,53,56.42,53S42.87,49.23,42.87,40.58s6.68-12.44,13.55-12.44S70,31.94,70,40.58m-8.64,0a4.91,4.91,0,1,0-9.8,0,4.91,4.91,0,1,0,9.8,0\"></path><path class=\"cls-3\" d=\"M81.78,28.67l.53,2.59a6.35,6.35,0,0,1,5.76-3.17,8.58,8.58,0,0,1,6.24,2.55L90.76,37a5.65,5.65,0,0,0-4-1.44c-2.21,0-4.08,1.34-4.08,4.46V52.4H73.85V28.67Z\"></path><polygon class=\"cls-3\" points=\"105.41 18.78 105.41 35.64 110.36 28.67 120.2 28.67 120.2 29.05 111.89 39.81 121.55 51.87 121.55 52.4 111.56 52.4 105.41 44.14 105.41 52.4 96.52 52.4 96.52 18.78 105.41 18.78\"></polygon><path d=\"M12.32,11.85a6.38,6.38,0,0,1-4.57,1.81c-4.41,0-6.39-3-6.41-6.24A6.09,6.09,0,0,1,7.75,1,6.19,6.19,0,0,1,12.2,2.89L10.9,4.14A4.49,4.49,0,0,0,7.75,2.89,4.26,4.26,0,0,0,3.27,7.4a4.2,4.2,0,0,0,4.48,4.43A4.71,4.71,0,0,0,11,10.51Z\"></path><path d=\"M25.68,7.38c0,3.29-2,6.29-6.22,6.29A5.93,5.93,0,0,1,13.24,7.4,6.08,6.08,0,0,1,19.49,1c4.16,0,6.19,3.07,6.19,6.35m-6.22,4.5c3,0,4.29-2.13,4.29-4.46S22.47,2.85,19.49,2.8c-2.81,0-4.32,2-4.32,4.62,0,2.15,1.28,4.46,4.29,4.46\"></path><polygon points=\"36.38 9.9 36.38 1.25 38.32 1.25 38.32 13.41 36.85 13.41 29.95 4.83 29.95 13.41 27.99 13.41 27.99 1.25 29.48 1.25 36.38 9.9\"></polygon><path d=\"M46,1.25a5.76,5.76,0,0,1,6.1,6A5.76,5.76,0,0,1,46,13.41h-4.6V1.25ZM43.31,11.54H46a4,4,0,0,0,4.17-4.33A4,4,0,0,0,46,3.11H43.31Z\"></path><path d=\"M66.1,7.38c0,3.29-2,6.29-6.22,6.29A5.93,5.93,0,0,1,53.66,7.4,6.08,6.08,0,0,1,59.92,1C64.07,1,66.1,4.1,66.1,7.38m-6.22,4.5c3,0,4.29-2.13,4.29-4.46S62.89,2.85,59.92,2.8s-4.33,2-4.33,4.62c0,2.15,1.28,4.46,4.29,4.46\"></path><path d=\"M78.9,13.41H76.63l-3.71-4.2H70.35v4.2H68.41V1.23l5.66,0a4,4,0,0,1,4.29,4A3.59,3.59,0,0,1,75.06,9l3.63,4.05ZM70.35,3V7.44h3.7a2.1,2.1,0,0,0,2.33-2.17A2.17,2.17,0,0,0,74.07,3Z\"></path><path class=\"cls-3\" d=\"M125.3,23.73a15,15,0,0,0,4.37.75c2.89,0,6.09-1.24,6.09-5.14,0-3.38-2.79-4.53-6.16-5.11-4.49-.8-8.77-2.22-9.28-7.89A11.58,11.58,0,0,0,118.24,13,11.72,11.72,0,0,0,125.3,23.73Z\"></path><path class=\"cls-3\" d=\"M141.66,13a11.67,11.67,0,0,0-4.2-9h0l0,0a11.68,11.68,0,0,0-12.3-1.67,4.36,4.36,0,0,0-1,2.94c0,3,2.69,3.86,5.86,4.44,5,.89,9.67,2.67,9.67,9.64,0,.09,0,.17,0,.26A11.63,11.63,0,0,0,141.66,13Z\"></path></svg><br><span class=\"forgot-pass-header\">Nueva contraseña</span></h1><form class=\"form-horizontal\" name=\"resetForm\" ng-show=\"!passwordActualizada()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': resetForm.inputPassword.$invalid }\"><p class=\"login-input\" for=\"inputPassword\">Contraseña nueva</p><input type=\"password\" ng-model=\"inputPassword\" class=\"form-control login-background\" name=\"inputPassword\" complex-pass=\"\"> <span style=\"color: red;\" class=\"help-block error-block basic-block\">La contraseña debe tener al menos 8 caracteres</span></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetForm.inputConfirmPassword.$invalid }\"><p class=\"login-input\" for=\"inputConfirmPassword\">Confirmar contraseña</p><input type=\"password\" class=\"form-control login-background\" ng-model=\"inputConfirmPassword\" name=\"inputConfirmPassword\" placeholder=\"\" check-pass=\"{{resetForm.inputPassword.$viewValue}}\"><div class=\"form-group\"><span style=\"color: red;\" class=\"help-block error-block basic-block\">Las contraseñas no coinciden</span></div><span class=\"center clickable-span\" ng-click=\"volver()\">Volver al inicio de sesión</span></div><div class=\"form-group\"><div class=\"align-center\"><button type=\"submit\" ng-click=\"cambiarPassword()\" class=\"btn btn-default btn-auth\">Confirmar</button></div></div></form><div ng-show=\"passwordActualizada()\"><p>La contraseña fue actualizada correctamente.</p></div></div></main>");
$templateCache.put("app/pages/sides/sides.html","<main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }\"><ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div ui-view=\"\" autoscroll=\"true\" autoscroll-body-top=\"\"></div></div></div><back-top></back-top></main><div id=\"preloader\" ng-show=\"!$pageFinishedLoading\"><div></div></div>");
$templateCache.put("app/pages/capacitaciones/capacitaciones/capacitaciones.html","<div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Capacitaciones disponibles\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><table ng-table=\"capacitacionsCargados\" st-table=\"displayedCollection\" st-safe-src=\"capacitacionsCollection\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"nomrubcurso\" class=\"align-center\">Capacitación</th><th st-sort=\"nomcodcurso\" class=\"text-center\">Detalle</th><th st-sort=\"fechapr\" class=\"text-center\">Fecha</th><th st-sort=\"renglon\" st-sort-default=\"reverse\" class=\"text-center\">Horario</th><th st-sort=\"lugar\" class=\"text-center\">Lugar</th><th st-sort=\"descestado\" class=\"text-center\">Estado</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"align-center\">{{item.nomrubcurso}}</td><td class=\"text-center\">{{item.nomcodcurso}}</td><td class=\"text-center\">{{item.fechapr}}</td><td class=\"text-center\">{{item.horadpr}} a {{item.horahpr}}hs</td><td class=\"text-center\">{{item.lugar}}</td><td class=\"text-center\">{{item.descestado}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Capacitaciones\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><table ng-table=\"capacitacionsCargados\" st-table=\"displayedCollection\" st-safe-src=\"capacitacionSolicitadas\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"nomrubcurso\" class=\"align-center\">Capacitación</th><th st-sort=\"nomcodcurso\" class=\"text-center\">Detalle</th><th st-sort=\"fechapr\" class=\"text-center\">Fecha</th><th st-sort=\"renglon\" st-sort-default=\"reverse\" class=\"text-center\">Horario</th><th st-sort=\"lugar\" class=\"text-center\">Lugar</th><th st-sort=\"descestado\" class=\"text-center\">Estado</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"align-center\">{{item.nomrubcurso}}</td><td class=\"text-center\">{{item.nomcodcurso}}</td><td class=\"text-center\">{{item.fechapr}}</td><td class=\"text-center\">{{item.horadpr}} a {{item.horahpr}}hs</td><td class=\"text-center\">{{item.lugar}}</td><td class=\"text-center\">{{item.descestado}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div>");
$templateCache.put("app/pages/familiares/modals/familiaresModal.html","<div class=\"modal-content\"><form ng-submit=\"actualizarFamiliar();\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss()\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Modificar datos del familiar</h4></div><div class=\"modal-body\"><div><label>Nombre</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.nombre\" maxlength=\"40\" ng-required=\"true\"></div><div><label style=\"margin-top: 10px;\" for=\"fechaNacimiento\">Fecha de Nacimiento</label><p class=\"input-group\"><input class=\"form-control\" ng-model=\"datePickerFnacim\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"LegajoCtrlDateFnacim\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" autoclose=\"true\" keyboard=\"true\" change=\"onChangeDateFnacim(newValue)\" ng-required=\"true\"></p></div><div><label>Sexo</label><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptionsSexo\" id=\"inlineRadio1\" value=\"1\" ng-model=\"familiaresModalData.sexo\" ng-required=\"true\"> <span>Masculino</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptionsSexo\" id=\"inlineRadio2\" value=\"2\" ng-model=\"familiaresModalData.sexo\" ng-required=\"true\"> <span>Femenino</span></label></div></div></div><div><label style=\"margin-top: 10px;\">Nacionalidad</label><select ng-model=\"familiaresModalData.codnac\" class=\"form-control\" ng-options=\"nacionalidades.codnac as nacionalidades.desccodnac for nacionalidades in nacionalidadesBase\" ng-required=\"true\" id=\"codnac\"></select></div><div><label style=\"margin-top: 10px;\">Estado civil</label><select ng-model=\"familiaresModalData.ecivil\" class=\"form-control\" ng-options=\"estCivil.codigo as estCivil.valor for estCivil in estadosCivilesBase\" ng-required=\"true\" id=\"ecivil\"></select></div><div><label style=\"margin-top: 10px;\" for=\"fechaCasamiento\">Fecha de Casamiento</label><p class=\"input-group\"><input class=\"form-control\" ng-model=\"datePickerFcasam\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"LegajoCtrlDateFcasam\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" autoclose=\"true\" keyboard=\"true\" change=\"onChangeDateFcasam(newValue)\"></p></div><div><label>A cargo para salario familiar</label><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptionsSalario\" id=\"inlineRadio1\" value=\"1\" ng-model=\"familiaresModalData.codac\" ng-disabled=\"true\"> <span>Si</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptionsSalario\" id=\"inlineRadio2\" value=\"0\" ng-model=\"familiaresModalData.codac\" ng-disabled=\"true\"> <span>No</span></label></div></div></div><div><label style=\"margin-top: 10px;\">Fecha alta a cargo para salario familiar</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.faltaac\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Fecha alta Obra Social</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.faltaos\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Fecha baja Obra Social</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.fbajaos\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Fecha alta IGAN</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.faltaig\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Fecha baja IGAN</label> <input type=\"text\" class=\"form-control\" ng-model=\"familiaresModalData.fbajaig\" ng-readonly=\"true\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button> <button type=\"submit\" class=\"btn btn-danger\">Guardar cambios</button></div></form></div>");
$templateCache.put("app/pages/licencias/solicitarLicencias/solicitarLicencias.html","<form ng-submit=\"enviarSolicitudLic()\"><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"Solicitud de Licencias\" ba-panel-class=\"panel light-text\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"licencias\">Licencia</label><select class=\"form-control\" ng-model=\"licencias.codnov\" ng-options=\"obj.codnov as obj.desccodnov for obj in pedirLicencias | orderBy : \'codnov\'\" ng-required=\"true\" ng-change=\"validoDia()\"><option value=\"\">-- Elegir Licencia --</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"fechaDesde\">Fecha desde</label> <input class=\"form-control\" ng-model=\"licencias.fsalida1\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"licenciasCtrlFsalida\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" min-date=\"min\" autoclose=\"true\" keyboard=\"true\" ng-required=\"true\" change=\"onChangeDateFlic(newValue)\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\" ng-if=\"licencias.codnov != 4 && licencias.codnov != 5\"><div class=\"form-group\"><label for=\"inputFirstName\">Cantidad de días</label> <input type=\"number\" ng-model=\"licencias.unidad\" class=\"form-control\" id=\"cantdias\" min=\"1\" ng-required=\"true\"></div></div><div class=\"col-sm-3\" ng-if=\"licencias.codnov == 4 || licencias.codnov == 5\"><div class=\"form-group\"><label for=\"inputFirstName\">Cantidad de horas</label> <input type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"licencias.horas\" placeholder=\"Horas\" min=\"0\" max=\"24\" ng-init=\"licencias.horas = 0\" required=\"\"></div></div><div class=\"col-sm-3\" ng-if=\"licencias.codnov == 4 || licencias.codnov == 5\"><div class=\"form-group\"><label for=\"inputFirstName\">Cantidad de minutos</label> <input type=\"number\" step=\"1\" class=\"form-control\" ng-model=\"licencias.minutos\" placeholder=\"Minutos\" min=\"0\" max=\"59\" ng-init=\"licencias.minutos = 0\" required=\"\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Ingresar observaciones</label> <input type=\"text\" ng-model=\"licencias.observaciones\" class=\"form-control\" id=\"observaciones\" maxlength=\"100\"></div></div></div><br><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\">Solicitar licencia</button></div></div><div ba-panel=\"\" ba-panel-title=\"Licencias solicitadas\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"licenciasSolicitadas\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"desccodnov\" class=\"text-center\">Licencia</th><th st-sort=\"fsalida\" class=\"text-center\">Fecha desde</th><th st-sort=\"unidad\" class=\"text-center\">Cantidad</th><th st-sort=\"comentario\" class=\"text-center\">Observaciones</th><th st-sort=\"descestado\" class=\"text-center\">Estado de la solicitud</th><th st-sort=\"id\" st-sort-default=\"reverse\" class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"text-center\">{{item.desccodnov}}</td><td class=\"text-center\">{{item.fsalida}}</td><td class=\"text-center\">{{item.unidad}}</td><td class=\"text-center\">{{item.comentario}}</td><td class=\"text-center\">{{item.descestado}}</td><td class=\"text-center\"><div class=\"buttons\" ng-show=\"item.descestado == \'Ingresado\'\"><button type=\"button\" class=\"btn btn-secondary editable-table-button btn-xs\" ng-click=\"onDelete(item)\">Cancelar</button></div></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div></form>");
$templateCache.put("app/pages/login/modals/elegirEmpresaModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Seleccionar Empresa</h4></div><div class=\"modal-body\"><label>Empresa</label><select ng-model=\"empresa\" class=\"form-control\" ng-options=\"e.empresa.nombre for e in empresas\"></select><br></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"closeModal()\">Aplicar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"dismissModal()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/login/modals/olvidoSuContraseñaModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">¿Olvidó su contraseña?</h4></div><div class=\"modal-body\"><p>Por favor solicite al administrador de SelfService el reinicio de su contraseña</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">Aceptar</button></div></div>");
$templateCache.put("app/pages/recibos/modals/firmarRecibosDiscModal.html","<div class=\"modal-content\"><form ng-submit=\"firmarReciboDisconforme();\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Firmar recibo en disconformidad</h4></div><div class=\"modal-body\"><div><label>Por favor ingrese el motivo por el cual manifiesta su disconformidad</label> <textarea maxlength=\"400\" class=\"form-control\" ng-required=\"true\" ng-model=\"motivoDisconformidad\" name=\"motivoDisconformidad\" id=\"motivoDisconformidad\" cols=\"150\" rows=\"8\"></textarea></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\">Firmar en disconformidad</button></div></form></div>");
$templateCache.put("app/pages/recibos/modals/firmarRecibosModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Firmar recibo</h4></div><div class=\"modal-body\"><div ng-show=\"pdfSoporta==false\"><h5>Su navegador de internet no soporta visualizar archivos PDF</h5><p>Puede descargar el recibo y luego firmarlo.</p></div><div ng-show=\"pdfSoporta==true\" id=\"pdfcontainerdiv\" class=\"pdfobject-container\"></div></div><br><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"firmarRecibo(item.renglon)\">Firmar</button> <button type=\"button\" ng-disabled=\"item.edigital===\'D\'\" class=\"btn btn-danger\" ng-click=\"openModalFirmaDisconformidad(item.renglon)\">Firmar no conforme</button></div></div>");
$templateCache.put("app/pages/dashboard/blurFeed/blurFeed.html","<table st-table=\"displayedCollection\" st-safe-src=\"novedades\" class=\"table\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr></thead><tbody><h4 class=\"text-left text-style-feed\">CARTELERA DE NOVEDADES</h4><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td style=\"width: 100px\"><div style=\"margin-left: 20px;\" ng-init=\"logo = logoCartelera\"><img style=\"padding-top: 10px; width: 100%; height: 100%;\" ng-src=\"{{::( logo | profilePicture )}}\"></div></td><td class=\"text-block text-message\"><div class=\"message-content line-clamp\"><span class=\"author\" style=\"font-size: 13px;\">{{item.titulo}}</span></div><div class=\"descripcion-feed\">{{::item.descripcion}}</div><div class=\"message-time\"><div class=\"fecha-feed\">{{::item.fechaAlta}}</div></div></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table>");
$templateCache.put("app/pages/supervisor/equipotrabajo/equipotrabajo.html","<div ng-show=\"rol == \'USER\'\"><p><i>Solo usuarios autorizados pueden acceder a la información de este módulo.</i></p></div><div class=\"widgets\" ng-show=\"rol == \'ADMIN\'\"><div ba-panel=\"\" ba-panel-title=\"Equipo de Trabajo\" ba-panel-class=\"with-scroll table-panel\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"equipoTrabajo\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"nivel\" st-sort-default=\"true\" class=\"text-center\">Nivel</th><th st-sort=\"descpuesto\" class=\"text-center\">Puesto</th><th st-sort=\"legajo\" st-sort-default=\"true\" class=\"text-center\">Legajo</th><th st-sort=\"nombre\" class=\"text-center\">Nombre</th><th st-sort=\"antigpuesto\" class=\"text-center\">Antigüedad en el Puesto</th><th st-sort=\"antigemp\" class=\"text-center\">Antigüedad en la Compañía</th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\" ng-style=\"set_color(item.nivel)\"><td class=\"text-center\">{{item.nivel}}</td><td class=\"text-center\">{{item.descpuesto}}</td><td class=\"text-center\">{{item.legajo}}</td><td class=\"text-center\">{{item.nombre}}</td><td class=\"text-center\">{{item.antigpuesto}}</td><td class=\"text-center\">{{item.antigemp}}</td><td class=\"text-center\"><div class=\"buttons\"><button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"openModalLegajo(item.legajo)\">Ver</button></div></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div>");
$templateCache.put("app/pages/supervisor/modals/rechazoLicModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Motivo de rechazo de la novedad</h4></div><div class=\"modal-body\"><div class=\"col-sm-12\"><div class=\"form-group\"><input type=\"text\" ng-model=\"rechazo.observaciones\" class=\"form-control\" id=\"observaciones\" maxlength=\"100\"></div></div></div><br><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"actualizarLicenciaSolRec(rechazo.observaciones)\">Aceptar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/supervisor/modals/rechazoVacModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Motivo rechazo de las vacaciones</h4></div><div class=\"modal-body\"><div class=\"col-sm-12\"><div class=\"form-group\"><input type=\"text\" ng-model=\"rechazo.observaciones\" class=\"form-control\" id=\"observaciones\" maxlength=\"100\"></div></div></div><br><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"actualizarVacacionSolRec(rechazo.observaciones)\">Aceptar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/supervisor/novedadespersonal/novedadespersonal.html","<div ng-show=\"rol == \'USER\'\"><p><i>Solo usuarios autorizados pueden acceder a la información de este módulo.</i></p></div><div class=\"widgets\" ng-show=\"rol == \'ADMIN\'\"><div ng-if=\"licenciasperSolicitadas.length != 0\" ba-panel=\"\" ba-panel-title=\"Novedades del personal pendientes por aprobar\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"text-center\">Legajo</th><th class=\"text-center\">Nombre</th><th class=\"text-center\">Novedad</th><th class=\"text-center\">Fecha Desde</th><th class=\"text-center\">Cantidad de Dias</th><th class=\"text-center\">Observaciones</th><th class=\"text-center\">Estado</th><th class=\"text-center\" ng-show=\"parchar942 == \'S\'\">Accion</th></tr></thead><tbody><tr ng-repeat=\"item in licenciasperSolicitadas | orderBy : \'-fecha\'\" class=\"no-top-border\"><td class=\"text-center\">{{item.legajo}}</td><td class=\"text-center\">{{item.nombre}}</td><td ng-if=\"item.desccodnov\" class=\"text-center\">{{item.desccodnov}}</td><td ng-if=\"!item.desccodnov\" class=\"text-center\">Vacaciones</td><td class=\"text-center\">{{item.fsalida}}</td><td class=\"text-center\">{{item.unidad}} {{item.dias}}</td><td class=\"text-center\">{{item.comentario}}</td><td class=\"text-center\">{{item.descestado}}</td><td class=\"text-center\" ng-show=\"parchar942 == \'S\'\"><div class=\"buttons\" ng-if=\"item.desccodnov\"><button class=\"btn btn-success editable-table-button btn-xs\" ng-click=\"actualizarLicenciaSol(\'P\', item.id, item.emp, item.legajo, item.codnov, item.desccodnov, item.unidad, item.fsalida, item.descestado, item.comentario, item.nombre)\">Aprobar</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"openModalRechazoLic(\'R\', item.id, item.emp, item.legajo, item.codnov, item.desccodnov, item.unidad, item.fsalida, item.descestado, item.comentario, item.nombre)\">Rechazar</button></div><div class=\"buttons\" ng-if=\"!item.desccodnov\"><button class=\"btn btn-success editable-table-button btn-xs\" ng-click=\"actualizarVacacionesSol(\'P\', item.id, item.emp, item.legajo, item.dias, item.fsalida, item.descestado, item.comentario, item.nombre)\">Aprobar</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"openModalRechazoVac(\'X\', item.id, item.emp, item.legajo, item.dias, item.fsalida, item.descestado, item.comentario, item.nombre)\">Rechazar</button></div></td></tr></tbody></table></div></div></div><div class=\"calendar-card\"><h4 class=\"text-left text-style\">NOVEDADES DEL PERSONAL</h4><hr><div><button type=\"button\" class=\"btn btn-default\" mwl-date-modifier=\"\" date=\"viewDate\" decrement=\"calendarView\" ng-click=\"cellIsOpen = false;load()\">Anterior</button> <button type=\"button\" class=\"btn btn-primary\" mwl-date-modifier=\"\" date=\"viewDate\" set-to-today=\"\" ng-click=\"cellIsOpen = false;load()\" style=\"margin-left: 6px; margin-right: 6px\">Hoy</button> <button type=\"button\" class=\"btn btn-default\" mwl-date-modifier=\"\" date=\"viewDate\" increment=\"calendarView\" ng-click=\"cellIsOpen = false;load()\">Siguiente</button><h4 style=\"margin-top: 20px; margin-bottom: 10px\" class=\"text-center\">{{calendarTitle | uppercase}}</h4></div><div ng-show=\"loading\" class=\"loader\"><i class=\"fa fa-circle-o-notch fa-spin\" style=\"font-size:24px\"></i></div><div ng-show=\"!loading\"><mwl-calendar events=\"events\" view=\"calendarView\" view-date=\"viewDate\" view-title=\"calendarTitle\" on-event-click=\"eventClicked(calendarEvent)\" on-view-change-click=\"false\" cell-is-open=\"cellIsOpen\" cell-modifier=\"modifyCell(calendarCell)\" cell-auto-open-disabled=\"true\" on-timespan-click=\"timespanClicked(calendarDate, calendarCell)\"></mwl-calendar></div></div></div><div class=\"widgets\" ng-show=\"rol == \'ADMIN\'\"><div ba-panel=\"\" ba-panel-title=\"Detalle de novedades del personal\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"licenciasperActualizadas\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"legajo\" class=\"text-center\">Legajo</th><th st-sort=\"nombre\" class=\"text-center\">Nombre</th><th st-sort=\"desccodnov\" class=\"text-center\">Novedad</th><th st-sort=\"fecha\" st-sort-default=\"reverse\" class=\"text-center\">Fecha Desde</th><th st-sort=\"unidad\" class=\"text-center\">Cantidad de Dias</th><th st-sort=\"comentario\" class=\"text-center\">Observaciones</th><th st-sort=\"descestado\" class=\"text-center\">Estado</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"text-center\">{{item.legajo}}</td><td class=\"text-center\">{{item.nombre}}</td><td ng-if=\"item.desccodnov\" class=\"text-center\">{{item.desccodnov}}</td><td ng-if=\"!item.desccodnov\" class=\"text-center\">Vacaciones</td><td class=\"text-center\">{{item.fsalida}}</td><td class=\"text-center\">{{item.unidad}} {{item.dias}}</td><td class=\"text-center\">{{item.comentario}}</td><td class=\"text-center\">{{item.descestado}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/supervisor/solicitarpersonal/solicitarpersonal.html","<div ng-show=\"rol == \'USER\'\"><p><i>Solo usuarios autorizados pueden acceder a la información de este módulo.</i></p></div><div class=\"widgets\" ng-show=\"rol == \'ADMIN\'\"><form ng-submit=\"SolicitarPersonal()\"><div ba-panel=\"\" ba-panel-title=\"Solicitar Personal\" ba-panel-class=\"panel light-text\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"empresa\">Empresa</label><select ng-model=\"personal.empresa\" class=\"form-control\"><option value=\"\">{{emp}}</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"puesto\">Puesto</label><select class=\"form-control\" ng-model=\"personal.puestos\" ng-options=\"puesto as puesto.nombre for puesto in puestos | orderBy : \'codnov\'\" ng-required=\"true\"><option value=\"\">-- Elegir Puesto --</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Motivo de solicitud</label><select class=\"form-control\" ng-model=\"personal.motivo\" ng-options=\"motivo as motivo.nombre for motivo in motivo | orderBy : \'codnov\'\" ng-required=\"true\"><option value=\"\">-- Motivo de Solicitud --</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Género</label><select class=\"form-control\" ng-model=\"personal.genero\" ng-init=\"genero = options[0]\" ng-required=\"true\"><option value=\"\" selected=\"\">-- Elegir Género --</option><option value=\"1\">Masculino</option><option value=\"2\">Femenino</option><option value=\"3\">Indistinto</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Lugar de Trabajo</label><select class=\"form-control\" ng-model=\"personal.lugarTrabajo\" ng-options=\"lugarTrabajo as lugarTrabajo.nombre for lugarTrabajo in lugarTrabajo\" ng-required=\"true\"><option value=\"\">-- Lugar de Trabajo --</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Causa</label><select class=\"form-control\" ng-model=\"personal.causa\" ng-options=\"causa as causa.nombre for causa in causa\" ng-required=\"true\"><option value=\"\">-- Causa --</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Edad</label><rzslider class=\"custom-slider\" rz-slider-model=\"slider.minValue\" rz-slider-high=\"slider.maxValue\" rz-slider-options=\"slider.options\"></rzslider></div>{{slider.value}}</div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"turno\">Turno</label><select class=\"form-control\" ng-model=\"personal.turnoSel\" ng-options=\"turno as turno.nombre for turno in turnos | orderBy : \'id\'\" ng-required=\"true\"><option value=\"\">-- Elegir Turno --</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">Observaciones</label> <textarea maxlength=\"400\" class=\"form-control\" ng-required=\"true\" ng-model=\"personal.observaciones\"></textarea></div></div></div><br><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\">Solicitar personal</button></div></div><div ba-panel=\"\" ba-panel-title=\"Personal solicitado\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"personalSolicitado\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"descpuesto\" class=\"text-center\">Puesto</th><th st-sort=\"descmotivo\" class=\"text-center\">Motivo</th><th st-sort=\"desccodlug\" class=\"text-center\">Lugar de Trabajo</th><th st-sort=\"descturno\" class=\"text-center\">Turno</th><th st-sort=\"fecsol\" class=\"text-center\">Fecha de Solicitud</th><th st-sort=\"descestado\" class=\"text-center\">Estado de la Solicitud</th><th st-sort=\"id\" st-sort-default=\"reverse\" class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"text-center\">{{item.descpuesto}}</td><td class=\"text-center\">{{item.descmotivo}}</td><td class=\"text-center\">{{item.desccodlug}}</td><td class=\"text-center\">{{item.descturno}}</td><td class=\"text-center\">{{item.fecsol}}</td><td class=\"text-center\">{{item.descestado}}</td><td class=\"text-center\"><div class=\"buttons\" ng-show=\"item.estado == \'PE\'\"><button type=\"button\" class=\"btn btn-secondary editable-table-button btn-xs\" ng-click=\"onDelete(item)\">Cancelar</button></div></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></form></div>");
$templateCache.put("app/pages/vacaciones/solicitarVacaciones/solicitarVacaciones.html","<form ng-submit=\"enviarSolicitud()\"><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"Solicitud de vacaciones\" ba-panel-class=\"panel light-text\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"periodoVacaciones\">Periodo de vacaciones</label><select class=\"form-control\" ng-model=\"periodo.periodo\" ng-options=\"obj.periodo for obj in pedirVacaciones\" ng-required=\"true\" ng-change=\"onChangeMaxDias(periodo.periodo)\"><option value=\"\">-- Elegir Periodo --</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"fechaNacimiento\">Fecha desde</label> <input class=\"form-control\" ng-model=\"vacaciones.fsalida1\" ng-model-options=\"{ updateOn: \'blur\' }\" moment-picker=\"vacacionesCtrlFsalida\" locale=\"es\" tabindex=\"0\" format=\"DD/MM/YYYY\" autoclose=\"true\" keyboard=\"true\" min-date=\"min\" change=\"onChangeDateFvac(newValue)\" ng-required=\"true\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Cantidad de días</label><input type=\"number\" ng-model=\"vacaciones.cantdias\" class=\"form-control\" id=\"cantdias\" min=\"1\" ng-required=\"true\" max=\"{{maxDias}}\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Ingresar observaciones</label> <input type=\"text\" ng-model=\"vacaciones.observaciones\" class=\"form-control\" id=\"observaciones\" maxlength=\"100\"></div></div></div><br><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\">Solicitar vacaciones</button></div></div><div ba-panel=\"\" ba-panel-title=\"Vacaciones solicitadas\" ba-panel-class=\"with-scroll table-panel\"><button type=\"button\" class=\"btn btn-default\" data-toggle=\"modal\" ng-click=\"openModalReciboVacaciones()\">Notificación de las vacaciones</button><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"vacacionesSolicitadas\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th st-sort=\"periodo\" class=\"text-center\">Periodo</th><th st-sort=\"fsalida\" class=\"text-center\">Fecha desde</th><th st-sort=\"dias\" class=\"text-center\">Cantidad de días</th><th st-sort=\"comentario\" class=\"text-center\">Observaciones</th><th st-sort=\"id\" st-sort-default=\"reverse\" class=\"text-center\">Estado de la solicitud</th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection\" class=\"no-top-border\"><td class=\"text-center\">{{item.periodo}}</td><td class=\"text-center\">{{item.fsalida}}</td><td class=\"text-center\">{{item.dias}}</td><td class=\"text-center\">{{item.comentario}}</td><td class=\"text-center\">{{item.descestado}}</td><td class=\"text-center\"><div class=\"buttons\" ng-show=\"item.descestado == \'Ingresado\'\"><button type=\"button\" class=\"btn btn-secondary editable-table-button btn-xs\" ng-click=\"onDelete(item)\">Cancelar</button></div></td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div><div ba-panel=\"\" ba-panel-title=\"Informe detallado de las vacaciones\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll\"><div class=\"table-responsive\"><table st-table=\"displayedCollection\" st-safe-src=\"tablaVacaciones\" class=\"table table-hover\"><thead><tr><th colspan=\"12\"><input st-search=\"\" class=\"form-control\" placeholder=\"Buscar\" type=\"text\"></th></tr><tr class=\"black-muted-bg\"><th class=\"text-center\">Periodo</th><th class=\"text-center\">Días totales</th><th class=\"text-center\">Días utilizados</th><th class=\"text-center\">Días pendientes</th></tr></thead><tbody><tr ng-repeat=\"item in displayedCollection | orderBy : \'-periodo\'\" class=\"no-top-border\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" data-toggle=\"modal\" ng-click=\"openModalVacaciones(item)\">{{item.periodo}}</button></td><td class=\"text-center\">{{item.diasTotales}}</td><td class=\"text-center\">{{item.diasUtilizados}}</td><td class=\"text-center\">{{item.diasTotales - item.diasUtilizados}}</td></tr></tbody><tfoot><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"itemsByPage\" st-displayed-pages=\"7\"></div></td></tr></tfoot></table></div></div></div></div></form>");
$templateCache.put("app/pages/vacaciones/modals/recibosVacacionesModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Reportes de notificación de vacaciones</h4></div><div class=\"modal-body\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th></th><th class=\"align-center\">Nombre del archivo</th><th class=\"align-center\">Fecha de emisión</th><th class=\"align-center\">Descargar</th></tr></thead><tbody><tr ng-repeat=\"item in recibosCollection\" class=\"no-top-border\"><td></td><td class=\"align-center\">{{item.nombre}}</td><td class=\"align-center\">{{item.fechaAlta}}</td><td class=\"align-center\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"getRecibo(item.renglon);\"><i class=\"ion-archive\"></i></button></td></tr></tbody></table></div><br><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">Aceptar</button></div></div>");
$templateCache.put("app/pages/vacaciones/modals/vacacionesModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Detalle de las vacaciones por periodo</h4></div><div class=\"modal-body\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"align-center\">Cantidad de días</th><th class=\"align-center\">Fecha de salida</th><th class=\"align-center\">Condición</th><th class=\"align-center\">Liquidación</th></tr></thead><tbody><tr class=\"no-top-border\"><td class=\"align-center\">{{vacacionesCollection.dias}}</td><td class=\"align-center\">{{vacacionesCollection.fsalida}}</td><td class=\"align-center\">{{vacacionesCollection.condicionDescripcion}}</td><td class=\"align-center\">{{vacacionesCollection.liquidacionDescripcion}}</td></tr></tbody></table></div><br><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">Aceptar</button></div></div>");
$templateCache.put("app/theme/inputs/baSwitcher/baSwitcher.html","<label class=\"switcher-container\"><input type=\"checkbox\" ng-model=\"switcherValue\"><div class=\"switcher\" ng-class=\"::switcherStyle\"><div class=\"handle-container\"><span class=\"handle handle-on\">ON</span> <span class=\"handle\"></span> <span class=\"handle handle-off\">OFF</span></div></div></label>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div><div id=\"chat-circle\" class=\"btn btn-raised closed\"><div id=\"chat-overlay\"></div><i class=\"ion-help\"></i></div><div class=\"chat-box\"><div class=\"list-box\"><div class=\"list-box-header\"><h5>Opciones</h5><span class=\"list-box-toggle\"><i class=\"ion-android-close\"></i></span></div><select name=\"\" class=\"select-box\" id=\"cusSelectbox\" size=\"6\"><option>Vacaciones</option><option>Licencias</option><option>Recibos de Haberes</option><option>Sugerencias</option><option>Otras consultas</option></select></div><div class=\"chat-box-header\">&nbsp;&nbsp;<b>Asistente Virtual</b> <span class=\"chat-box-toggle\"><i class=\"ion-android-close\"></i></span></div><div class=\"chat-box-body\"><div class=\"chat-box-overlay\"><div class=\"chat-logs\"></div></div><div class=\"chat-input\"><form><input type=\"text\" autocomplete=\"off\" id=\"chat-input\" placeholder=\"Escribir consulta\"> <button type=\"button\" class=\"chat-option\" id=\"chat-option\"><span class=\"glyphicon glyphicon-th-list\"></span></button> <button type=\"submit\" class=\"chat-submit\" id=\"chat-submit\"><span class=\"glyphicon\">&#xe171;</span></button></form></div></div></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"user-profile clearfix\" style=\"right: 0%;position: fixed\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><i class=\"fa fa-gear fa-3x\" style=\"color: grey\"></i></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a href=\"#/dashboard/perfil\"><i class=\"fa fa-user\"></i>Perfil</a></li><li><a href=\"\" class=\"signout\" ng-click=\"logout()\"><i class=\"fa fa-power-off\"></i>Cerrar Sesión</a></li></ul></div><div><ul class=\"al-msg-center clearfix\" ng-show=\"nombreRol == \'ADMIN\'\" ng-click=\"limpiar1();limpiar()\"><li uib-dropdown=\"\" class=\"dropdown-toggle notify-bell\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell\" style=\"color:gray;\"></i> <span style=\"color:white;\">{{((newsNotiLic | filter: {estado: \'I\'}).length + (newsNotiVac | filter: {estado: \'I\'}).length) | limitTo:100 }}</span></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Tiene {{(newsLic | filter: {estado: \'I\'}).length | limitTo:100 }} novedades del personal</strong></div><div class=\"msg-list\"><a href=\"#/dashboard/supervisor/supervisor/novedadespersonal\" class=\"clearfix\" ng-repeat=\"notificacion in newsLic | orderBy : \'-id\' | limitTo : 100 track by notificacion.id\"><div><span style=\"font-style: italic;text-align: left;display: block;font-size: 11px;\">El legajo {{ notificacion.legajo}} solicitó {{ notificacion.desccodnov}}</span></div></a></div><div class=\"header clearfix\"><strong>Tiene {{(newsVac | filter: {estado: \'I\'}).length | limitTo:100 }} vacaciones</strong></div><div class=\"msg-list\"><a href=\"#/dashboard/supervisor/supervisor/novedadespersonal\" class=\"clearfix\" ng-repeat=\"notificacion in newsVac | orderBy : \'-id\' | limitTo : 100 track by notificacion.id\"><div><span style=\"font-style: italic;text-align: left;display: block;font-size: 11px;\">El legajo {{ notificacion.legajo}} solicitó vacaciones</span></div></a></div><a href=\"#/dashboard/supervisor/supervisor/novedadespersonal\">Ir a novedades</a></div></li></ul></div><div class=\"nameUser text-right\" style=\"width: 300px\"><br><p>{{nombreUsuario}}&nbsp;&nbsp;</p></div></div><img src=\"/assets/img/condor_link_app.png\" class=\"link-logo-app-ml\"></div>");
$templateCache.put("app/theme/components/progressBarRound/progressBarRound.html","<svg class=\"center-block progress-bar-round\" width=\"200\" height=\"200\"><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" stroke=\"#F8F8FF\" stroke-width=\"8\"></circle><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" id=\"loader\" class=\"\" stroke=\"#209e91\" stroke-width=\"8\" stroke-dasharray=\"0,20000\" transform=\"rotate(-90,100,100)\" stroke-linecap=\"round\"></circle><text text-anchor=\"middle\" class=\"loading\" x=\"100\" y=\"90\">Loading...</text><text class=\"percentage\" text-anchor=\"middle\" x=\"100\" y=\"130\">{{progress}}%</text></svg>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1></div>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/pages/supervisor/equipotrabajo/modals/legajoModal.html","<div class=\"modal-content\"><form><div class=\"modal-header\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss()\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Detalles del legajo</h4></div><div class=\"modal-body\"><div><label style=\"margin-top: 10px;\">Nombre</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.nombre\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Fecha de Nacimiento</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.fnacim\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Estado Civil</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.ecivil\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Cantidad de Hijos</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.canthijos\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">e-mail</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.email\" ng-readonly=\"true\"></div><div><label style=\"margin-top: 10px;\">Telefono de Contacto</label> <input type=\"text\" class=\"form-control\" ng-model=\"legajoModalData.telef\" ng-readonly=\"true\"></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Aceptar</button></div></form></div>");}]);